export const stageItem = {
    none: 0,
    get: 1,
    move: 2,
    moveEnd: 3,
    info: 4,
    useGet: 5,
	useItem: 6,
	fastClick: 7,
	moveBlock: 7
}

export const clearSlot = {
    use: true,
    hover: false,
    active: false,
    ItemId: 0,
    item_type: 0,
    item_amount: 0,
    item_money: 0
};

export const defaulSelectItem = {
    use: stageItem.none,
    width: 0,
    height: 0
};

export const defaulHoverItem = {
    id: -1,
    arrayName: false
};

export const getInfo = {
    inventory: 1,
    weapons: 2,
    accessories: 3,
    backpack: 4,
    other: 5,
    Inv_VehicleUpgrades: 6,
    Inv_VehicleTuning: 7,
    trade: 8
};

export const maxSlots = {
    accessories: 15,
    inventory: 50,
    backpack: 20,
    other: 25,
    fastSlots: 5,        
    trade: 35,
    with_trade: 45,
}

export const otherName = [
    {//0
        name: "",
		descr: "",
        icon: "",
    }, 
    {//1
        name: "Машина",
		descr: "Помните, что другие игроки могут красть из него вещи",
        icon: "inventoryicons-car",
    },    
    {//2
        name: "Сейф",
		descr: "Помните, что другие игроки могут красть из него вещи",
        icon: "inventoryicons-delivery-box",
    },
    {//3
        name: "Гардероб",
		descr: "Помните, что другие игроки могут красть из него вещи",
        icon: "inventoryicons-delivery-box",
    },
    {//4
        name: "Шкаф",
		descr: "Помните, что другие игроки могут красть из него вещи",
        icon: "inventoryicons-delivery-box",
    },
    {//5
        name: "Склад фракций",
		descr: "Помните, что другие игроки могут украсть вещи со склада.",
        icon: "inventoryicons-open-box",
    },
    {//6
        name: "Склад семьи",
		descr: "Помните, что другие игроки могут украсть вещи со склада.",
        icon: "inventoryicons-open-box"
    },
    {//7
        name: "Связка",
		descr: "Связка ключей",
        icon: "inventoryicons-open-padlock",
    },
    {//8
        name: "Рядом",
		descr: "Предметы, которые находятся на полу рядом с вами.",
        icon: "inventoryicons-drop",
    },
    {//9
        name: "Модификации",
		descr: "Модификации, установленные в оружии.",
        icon: "inventoryicons-rifle",
    },
    {//10
        name: "Хранилище",
		descr: "Место, где хранятся награды и посылки.",
        icon: "inventoryicons-padlock",
    },
    {//11
        name: "Палатка",
		descr: "Торговая палатка, в которой можно приобрести что-нибудь интересное.",
        icon: "inventoryicons-shop-cart",
    },
    {//12
        name: "Коробка",
        descr: "Место, где хранятся награды и посылки.",
        icon: "inventoryicons-padlock",
    },
    {//13
        name: "Склад хранения",
        descr: "Место хранения предметов для маркетплейса",
        icon: "inventoryicons-open-box",
    },
    {//14
    name: "Семейный склад",
    descr: "Место для хранения вещей вашей семьи.",
    icon: "inventoryicons-delivery-box",
},
]

export const otherType = {
	None: 0,
	Vehicle: 1,
	Safe: 2,
	Wardrobe: 3,
	Chiffonier: 4,
	Fraction: 5,
	Organization: 6,
	Key: 7,
	Nearby: 8,
	wComponents: 9,
	Storage: 10,
	Tent: 11,
    Case: 12,
	MarketStorage: 13,
    PublicWarehouse: 14
}

export const clothesId = [
    "Hats",
    "Masks",
    "Ears",
    "Glasses",
    "Accessories",
    "Tops",
    "Undershirts",
    "Armors",
    "Bags",
    "Legs",
    "Bracelets",
    "Watches",
    "Torsos",
    "Shoes",
];

export const itemIdCaseToId = {
    250: 0,
    251: 1,
    252: 2,
    253: 3,
    254: 4,
    255: 5,
    256: 6,
    257: 7,
    258: 8,
    259: 9,
    260: 10,
    261: 11,
    262: 12,
    265: 13,
    268: 14,
    281: 15,
    282: 16,
    283: 17,
    284: 18,
    285: 19,
    286: 20,
    287: 21,
};


export const ItemToWeaponHash = {
	"109":"911657153",
	"136":"100416529",
	"137":"205991906",
	"139":"177293209",
	"140":"1785463520",
	"150":"-1355376991",
	"100":"453432689",
	"105":"137902532",
	"108":"584646201",
	"101":"1593441988",
	"107":"3249783761",
	"103":"3218215474",
	"104":"3523564046",
	"102":"2578377531",
	"152":"2441047180",
	"151":"727643628",
	"106":"3696079510",
	"110":"1198879012",
	"111":"2548703416",
	"112":"3219281620",
	"113":"2285322324",
	"114":"3415619887",
	"119":"171789620",
	"115":"324215364",
	"117":"736523883",
	"123":"3173288789",
	"116":"3675956304",
	"118":"4024951519",
	"153":"1198256469",
	"120":"2634544996",
	"121":"2144741730",
	"122":"1627465347",
	"124":"2024373456",
	"125":"3686625920",
	"127":"2210333304",
	"126":"3220176749",
	"129":"3231910285",
	"138":"3342088282",
	"128":"2937143193",
	"130":"2132975508",
	"131":"1649403952",
	"132":"961495388",
	"266":"-1658906650",
	"133":"4208062921",
	"134":"2526821735",
	"135":"2228681469",
	"141":"487013001",
	"146":"984333226",
	"144":"3800352039",
	"143":"2640438543",
	"142":"2017895192",
	"145":"2828843422",
	"147":"4019527611",
	"148":"317205821",
	"149":"1432025498"
}

export const WeaponHashToItem = {
    "911657153": "109",
    "100416529": "136",
    "205991906": "137",
    "177293209": "139",
	"1785463520": "140",
	"-1355376991": "150",
    "137902532": "105",
    "171789620": "119",
    "317205821": "148",
    "324215364": "115",
    "453432689": "100",
    "487013001": "141",
    "584646201": "108",
    "727643628": "151",
    "736523883": "117",
    "961495388": "132",
    "-1658906650": "266",
    "984333226": "146",
    "1198256469": "153",
    "1198879012": "110",
    "1432025498": "149",
    "1593441988": "101",
    "1627465347": "122",
    "1649403952": "131",
    "2017895192": "142",
    "2024373456": "124",
    "2132975508": "130",
    "2144741730": "121",
    "2210333304": "127",
    "2228681469": "135",
    "2285322324": "113",
    "2441047180": "152",
    "2526821735": "134",
    "2548703416": "111",
    "2578377531": "102",
    "2634544996": "120",
    "2640438543": "143",
    "2828843422": "145",
    "2937143193": "128",
    "3173288789": "123",
    "3218215474": "103",
    "3219281620": "112",
    "3220176749": "126",
    "3231910285": "129",
    "3249783761": "107",
    "3342088282": "138",
    "3415619887": "114",
    "3523564046": "104",
    "3675956304": "116",
    "3686625920": "125",
    "3696079510": "106",
    "3800352039": "144",
    "4019527611": "147",
    "4024951519": "118",
    "4208062921": "133"
}

export const clothesData = {
	"-12": {
		slotId: 0,
		event: "setPropIndex",
		componentId: 0
	},
	"-1": {
		slotId: 1,
		event: "setComponentVariation",
		componentId: 1
	},
	"-2": {
		slotId: 2,
		event: "setPropIndex",
		componentId: 2
	},
	"-13": {
		slotId: 3,
		event: "setPropIndex",
		componentId: 1
	},
	"-7": {
		slotId: 4,
		event: "setComponentVariation",
		componentId: 7
	},
	"-11": {
		slotId: 5,
		event: "setComponentVariation",
		componentId: 11
	},
	"-8": {
		slotId: 6,
		event: "setComponentVariation",
		componentId: 11
	},
	"-9": {
		slotId: 7,
		event: "setComponentVariation",
		componentId: 9
	},
	"-5": {
		slotId: 8,
		event: "setComponentVariation",
		componentId: 5
	},
	"-4": {
		slotId: 9,
		event: "setComponentVariation",
		componentId: 4
	},
	"-15": {
		slotId: 10,
		event: "setPropIndex",
		componentId: 7
	},
	"-14": {
		slotId: 11,
		event: "setPropIndex",
		componentId: 6
	},
	"-3": {
		slotId: 12,
		event: "setComponentVariation",
		componentId: 11
	},
	"-6": {
		slotId: 13,
		event: "setComponentVariation",
		componentId: 6
	},
}
export const clothes = {
    Hats: {// 0 - Hats
        slotId: 0,
        name: "Hats",
        type: "Hats",
        icon: "inv-item-cap",
        itemId: -12
    },
    Masks: {// 1 - Masks
        slotId: 1,
        name: "Masks",
        type: "Masks",
        icon: "inv-item-mask",
        itemId: -1
    },
    Ears: {// 2 - Ears
        slotId: 2,
        name: "Ears",
        type: "Ears",
        icon: "inv-item-ears",
        itemId: -2
    },
    Glasses: {// 3 - Glasses
        slotId: 3,
        name: "Glasses",
        type: "Glasses",
        icon: "inv-item-glasses",
        itemId: -13
    },
    Accessories: {// 4 - Accessories
        slotId: 4,
        name: "Accessories",
        type: "Accessories",
        icon: "inv-item-necklace",
        itemId: -7
    },
    Tops: {// 5 - Tops
        slotId: 5,
        name: "Tops",
        type: "Tops",
        icon: "inv-item-jacket",
        itemId: -11
    },
    Undershirts: {// 6 - Undershirts
        slotId: 6,
        name: "Undershirts",
        type: "Undershirts",
        icon: "inv-item-shirt",
        itemId: -8
    },
    Armors: {// 7 - Armors
        slotId: 7,
        name: "Armors",
        type: "Armors",
        icon: "inv-item-armor",
        itemId: -9
    },
    Bags: {// 8 - Bags
        slotId: 8,
        name: "Bags",
        type: "Bags",
        icon: "inv-item-backpack",
        itemId: -5
    },
    Legs: {// 9 - Legs
        slotId: 9,
        name: "Legs",
        type: "Legs",
        icon: "inv-item-shorts",
        itemId: -4
    },
    Bracelets: {// 10 - Bracelets
        slotId: 10,
        name: "Bracelets",
        type: "Bracelets",
        icon: "inv-item-bracelet",
        itemId: -15
    },
    Watches: {// 11 - Watches
        slotId: 11,
        name: "Watches",
        type: "Watches",
        icon: "inv-item-clock",
        itemId: -14
    },
    Torsos: {// 12 - Torsos
        slotId: 12,
        name: "Torsos",
        type: "Torsos",
        icon: "inv-item-glove",
        itemId: -3
    },
    Shoes: {// 13 - Shoes
        slotId: 13,
        name: "Shoes",
        type: "Shoes",
        icon: "inv-item-sneakers",
        itemId: -6
    },
    Suit: {// 14 - Suit
        slotId: 14,
        name: "Suit",
        type: "Suit",
        icon: "inv-item-headphones",
        itemId: -10
    }
}

export const clothesName = {
    "Masks_0": "Without a mask",
"Masks_1": "Pig",
"Masks_2": "Skull",
"Masks_3": "Pogo",
"Masks_4": "Hockey",
"Masks_5": "Gorilla",
"Masks_6": "Carnival",
"Masks_7": "Vampire",
"Masks_8": "Santa Claus",
"Masks_9": "Deer",
"Masks_10": "Snowman",
"Masks_11": "Mysterious",
"Masks_12": "Masquerade",
"Masks_13": "Cupid",
"Masks_14": "Hockey shot",
"Masks_15": "Hockey awesome",
"Masks_16": "Warrior",
"Masks_17": "Cat",
"Masks_18": "Fox",
"Masks_19": "Owl",
"Masks_20": "Raccoon",
"Masks_21": "Bear",
"Masks_22": "Bison",
"Masks_23": "Bull",
"Masks_24": "Eagle",
"Masks_25": "Vulture",
"Masks_26": "Wolf",
"Masks_27": "Pilot corn",
"Masks_28": "Tactical",
"Masks_29": "The skull is terrifying",
"Masks_30": "Hooligan hockey mask",
"Masks_31": "Penguin",
"Masks_32": "Sock",
"Masks_33": "Funny Cookie",
"Masks_34": "Elf",
"Masks_35": "Balaclava №1",
"Masks_36": "Respirator №1",
"Masks_37": "Balaclava №2",
"Masks_38": "Gas mask №1",
"Masks_39": "Carnivorous",
"Masks_40": "Mummy",
"Masks_41": "Bug-eyed vampire",
"Masks_42": "Frank",
"Masks_43": "Impotent Rage",
"Masks_44": "Princess Robot Bubblegum",
"Masks_45": "Moorehead",
"Masks_46": "Gas Mask №2",
"Masks_47": "Police duct tape",
"Masks_48": "Duct tape",
"Masks_49": "Package",
"Masks_50": "Lunar",
"Masks_51": "Bandana №1",
"Masks_52": "Balaclava №3",
"Masks_53": "Balaclava №4",
"Masks_54": "Balaclava №5",
"Masks_55": "Balaclava №6",
"Masks_56": "Balaclava №7",
"Masks_57": "Balaclava №8",
"Masks_58": "Balaclava №9",
"Masks_59": "Snowman",
"Masks_60": "Evil Pumpkin",
"Masks_61": "Zombie old man",
"Masks_62": "Risen from the ashes",
"Masks_63": "Anatomical",
"Masks_64": "Predator",
"Masks_65": "Werewolf",
"Masks_66": "Dragonfly",
"Masks_67": "Orc",
"Masks_68": "Devil",
"Masks_69": "Bag",
"Masks_70": "Hypnotist",
"Masks_71": "Baba Yaga",
"Masks_72": "Lucifer",
"Masks_73": "Without a mask",
"Masks_74": "Burnt cookie",
"Masks_75": "Cookie at a loss",
"Masks_76": "Santa with a hangover",
"Masks_77": "Christmas tree",
"Masks_78": "Kulich",
"Masks_79": "Yeti",
"Masks_80": "Yeti with LS cap",
"Masks_81": "Yeti with visor",
"Masks_82": "Yeti with headband",
"Masks_83": "Yeti with Santa hat",
"Masks_84": "Old Yeti",
"Masks_85": "Chicken",
"Masks_86": "Tooth Fairy",
"Masks_87": "Elf with a cigarette",
"Masks_88": "Grandma",
"Masks_89": "Tactical",
"Masks_90": "Tactical respirator",
"Masks_91": "Hi-tech",
"Masks_92": "Monster",
"Masks_93": "Dinosaur",
"Masks_94": "Devil with horns",
"Masks_95": "Clown",
"Masks_96": "Monkey",
"Masks_97": "Horse",
"Masks_98": "Unicorn",
"Masks_99": "Skull with patterns",
"Masks_100": "Pug",
"Masks_101": 'Bigness',
"Masks_102": "Spanish",
"Masks_103": "Digital zombie",
"Masks_104": "Ski",
"Masks_105": "Night Demon",
"Masks_106": "Tactical camouflage",
"Masks_107": "Protective camouflage",
"Masks_108": "Half-skull",
"Masks_109": "Pilot of the cornhusker №2",
"Masks_110": "Robot",
"Masks_111": "Bandana №2",
"Masks_112": "Snout",
"Masks_113": "Balaclava №10",
"Masks_114": "Open shemag",
"Masks_115": "Closed shemag",
"Masks_116": "Scarf-tube",
"Masks_117": "Balaclava №11",
"Masks_118": "T-shirt",
"Masks_119": "Balaclava №12",
"Masks_120": "Without mask",
"Masks_121": "Headset",
"Masks_122": "Open balaclava",
"Masks_123": "Digital",
"Masks_124": "Electric discharge",
"Masks_125": "Protective Mono",
"Masks_126": "Reinforced",
"Masks_127": "Beard",
"Masks_128": "Lunar",
"Masks_129": "Industrial gas mask",
"Masks_130": "Respirator with mirrored lenses",
"Masks_131": "Krampus",
"Masks_132": "Night vision device",
"Masks_133": "Hockey with brass knuckles",
"Masks_134": "Star Trek",
"Masks_135": "Robot Helmet",
"Masks_136": "Grey Vulture",
"Masks_137": "Trapper",
"Masks_138": "Raider",
"Masks_139": "Zombie-scoffer",
"Masks_140": "One-eyed monster",
"Masks_141": "Slanted Monster",
"Masks_142": "Marauder",
"Masks_143": "Paco The Taco",
"Masks_144": "Burger Shot",
"Masks_145": "Cluckin' Bell",
"Masks_146": "Optics",
"Masks_147": "Monkey with a cigarette",
"Masks_148": "Robin",
"Masks_149": "Strawberry",
"Masks_150": "Lemon",
"Masks_151": "Grape",
"Masks_152": "Pineapple",
"Masks_153": "Cherry",
"Masks_154": "Jackpot",
"Masks_155": "Joker",
"Masks_156": "King",
"Masks_157": "Queen",
"Masks_158": "Jack",
"Masks_159": "Skull in a hat",
"Masks_160": "Baby smile",
"Masks_161": "Maniac",
"Masks_162": "Piggy",
"Masks_163": "Bug-eyed monkey",
"Masks_164": "Broken smiley",
"Masks_165": "Cute rabbit",
"Masks_166": "Street respirator",
"Masks_167": "Sniper",
"Masks_168": "Skinless",
"Masks_169": "Bandana №3",
"Masks_170": "Observer",
"Masks_171": "Fox from the cartoon",
"Masks_172": "Cat from the cartoon",
"Masks_173": "Pig from the cartoon",
"Masks_174": "Balaclava with a smile",
"Masks_175": "Respirator with transparent lenses",
"Masks_176": "Cartoon Dog",
"Masks_177": "Cerberus",
"Masks_178": "Balaclava with a smile",
"Masks_179": "Emotions",
"Glasses_0_F": "Sports",
"Glasses_1_F": "Retro dragonfly",
"Glasses_2_F": "Retro",
"Glasses_3_F": "Protective",
"Glasses_4_F": "Retro with tiger frame",
"Glasses_5_F": "-",
"Glasses_6_F": "Dragonfly with purple lenses",
"Glasses_7_F": "Eight",
"Glasses_8_F": "Square with pink lenses",
"Glasses_9_F": "Sports with green lenses",
"Glasses_10_F": "Summer",
"Glasses_11_F": "Aviators",
"Glasses_12_F": "-",
"Glasses_13_F": "-",
"Glasses_14_F": "Cat's eye",
"Glasses_15_F": "-",
"Glasses_16_F": "Dragonfly with brown lenses",
"Glasses_17_F": "Square with purple lenses",
"Glasses_18_F": "Sports with dark transparent lenses",
"Glasses_19_F": "Sports with dark lenses",
"Glasses_20_F": "Square darkened",
"Glasses_21_F": "Square ordinary",
"Glasses_22_F": "Stars",
"Glasses_23_F": "Patriotic",
"Glasses_24_F": "Square dark",
"Glasses_25_F": "Shooting in a color frame",
"Glasses_26_F": "Vintage",
"Glasses_27_F": "Surfers",
"Glasses_28_F": "Scuba mask",
"Glasses_29_F": "Large",
"Glasses_30_F": "Hipster",
"Glasses_31_F": "Luxury",
"Hats_0_F": "Protective headphones",
"Hats_1_F": "Paper cap",
"Hats_2_F": "Cowboy Hat",
"Hats_3_F": "Panama light",
"Hats_4_F": "LS cap",
"Hats_5_F": "Short hat",
"Hats_6_F": "Hat with a visor",
"Hats_7_F": "Bully cap",
"Hats_8_F": "Elegant hat",
"Hats_9_F": "iFruit cap",
"Hats_10_F": "Baseball cap",
"Hats_11_F": "Beach hat",
"Hats_12_F": "Free Hat",
"Hats_13_F": "Straw Hat",
"Hats_14_F": "Beret",
"Hats_15_F": "Headphones Beat Off",
"Hats_16_F": "Western MC Helmet",
"Hats_17_F": "Open Helmet",
"Hats_18_F": "Closed motorcycle helmet",
"Hats_19_F": "Pilot's headphones",
"Hats_20_F": "Straw wavy hat",
"Hats_21_F": "Garden Panama hat",
"Hats_22_F": "Straw beach hat",
"Hats_23_F": "Santa Claus hat",
"Hats_24_F": "Hat and elf ears",
"Hats_25_F": "Horns",
"Hats_26_F": "Refined bowler hat",
"Hats_27_F": "Refined cylinder",
"Hats_28_F": "Detective hat",
"Hats_29_F": "Hooligan",
"Hats_30_F": "Patriot hat",
"Hats_31_F": "Patriot straight hat",
"Hats_32_F": "Patriot wavy hat",
"Hats_33_F": "Patriot hat",
"Hats_34_F": "Patriot tiara",
"Hats_35_F": "Patriotic stars",
"Hats_36_F": "Beer cap",
"Hats_37_F": "Closed pilot helmet",
"Hats_38_F": "Helmet with protection open",
"Hats_39_F": "Herringbone hat",
"Hats_40_F": "Mistletoe hat",
"Hats_41_F": "Long bubo hat",
"Hats_42_F": "Cap with a short bubon",
"Hats_43_F": "Cap 'Naughty'",
"Hats_44_F": "Cap with a visor back",
"Hats_45_F": "Police cap",
"Hats_46_F": "Pilot's helmet closed",
"Hats_47_F": "Off-road glossy helmet outdoor",
"Hats_48_F": "Off-road matte helmet",
"Hats_49_F": "Biker matte helmet closed",
"Hats_50_F": "Biker matte mirror helmet",
"Hats_51_F": "Biker glossy helmet",
"Hats_52_F": "Biker glossy mirror Helmet",
"Hats_53_F": "FAM cap",
"Hats_54_F": "Hat with a thin insert",
"Hats_55_F": "Cap 'Broker'",
"Hats_56_F": "Cap 'Cagnetica'",
"Hats_57_F": "Without a hat",
"Hats_58_F": "Cap with a fabric insert",
"Hats_59_F": "Bulletproof helmet with protection",
"Hats_60_F": "Military cap",
"Hats_61_F": "Hat with wide insert",
"Hats_62_F": "Motorcycle helmet",
"Hats_63_F": "Military cap straight",
"Hats_64_F": "Cap 'SecuroServ' with visor forward",
"Hats_65_F": "Cap 'SecuroServ' with visor back",
"Hats_66_F": "Open glossy motorcycle helmet",
"Hats_67_F": "Open frosted motorcycle helmet",
"Hats_68_F": "Open mirrored motorcycle helmet",
"Hats_69_F": "Open motorcycle helmet with glossy glass",
"Hats_70_F": "Open frosted mirror helmet",
"Hats_71_F": "Open Motorcycle Helmet №2",
"Hats_72_F": "Closed retro helmet",
"Hats_73_F": "Open Retro helmet",
"Hats_74_F": "Faggio helmet",
"Hats_75_F": "Cap 'ATOMIC'",
"Hats_76_F": "Bandit cap",
"Hats_77_F": "Closed DC helmet",
"Hats_78_F": "Open DC helmet",
"Hats_79_F": "Golden closed helmet DC",
"Hats_80_F": "Golden open helmet DC",
"Hats_81_F": "Closed motorcycle helmet",
"Hats_82_F": "Cotton hat",
"Hats_83_F": "Helmet with spikes",
"Hats_84_F": "Half helmet",
"Hats_85_F": "Half helmet with visor",
"Hats_86_F": "Half helmet with long spikes",
"Hats_87_F": "Half helmet with short spikes",
"Hats_88_F": "Cast iron helmet",
"Hats_89_F": "Chrome helmet",
"Hats_90_F": "Neon closed helmet",
"Hats_91_F": "Neon outdoor helmet",
"Hats_92_F": "Stunt helmet",
"Hats_93_F": "Panama walking",
"Hats_94_F": "Elegant hat",
"Hats_95_F": "Cap 'Bigness'",
"Hats_96_F": "Hat 'Herringbone'",
"Hats_97_F": "Hat with mistletoe'",
"Hats_98_F": "Hat with a long bubon",
"Hats_99_F": "New Year's hat with ears",
"Hats_100_F": "Horns with red bubon",
"Hats_101_F": "Strict cap",
"Hats_102_F": "Camouflage cap with insert",
"Hats_103_F": "Camouflage panama",
"Hats_104_F": "Camouflage cowboy hat",
"Hats_105_F": "Camouflage beret",
"Hats_106_F": "Military camouflage cap",
"Hats_107_F": "Camouflage hat",
"Hats_108_F": "H&L cap with visor forward",
"Hats_109_F": "H&L cap with visor back",
"Hats_110_F": "Airplane pilot helmet",
"Hats_111_F": "Camouflage helmet with clasp",
"Hats_112_F": "Military cap",
"Hats_113_F": "Cap",
"Hats_114_F": "Helmet mask",
"Hats_115_F": "Helmet with 2 lenses №1",
"Hats_116_F": "Helmet with 2 lenses №2",
"Hats_117_F": "Helmet with 4 lenses №1",
"Hats_118_F": "Helmet with 4 lenses №2",
"Hats_119_F": "Long hat",
"Hats_120_F": "-",
"Hats_121_F": "EMS cap",
"Hats_122_F": "Closed police helmet",
"Hats_123_F": "Open police helmet",
"Hats_124_F": "Closed translucent police helmet",
"Hats_125_F": "Open translucent police helmet",
"Hats_126_F": "Open Transparent motorcycle helmet",
"Hats_127_F": "Closed transparent motorcycle helmet",
"Hats_128_F": "Helmet from a spacesuit",
"Hats_129_F": "Cap 'Burger Shot' with visor forward",
"Hats_130_F": "Cap 'Burger Shot' with visor back",
"Hats_131_F": "Panama 'TacoBomb'",
"Hats_132_F": "Helmet from spacesuit №2",
"Hats_133_F": "Helmet from spacesuit №3",
"Hats_134_F": "Cap 'Diamond' with visor forward",
"Hats_135_F": "Cap 'Diamond' with visor back",
"Hats_136_F": "Helmet 'LSFD'",
"Hats_137_F": "Helmet 'LSFD' with glasses",
"Hats_138_F": "BugStars' cap with visor forward",
"Hats_139_F": "BugStats' cap with visor back",
"Hats_140_F": "Protective helmet with glasses",
"Hats_141_F": "Outdoor cap",
"Hats_142_F": "Helmet 'Gruppe Sechs'",
"Hats_143_F": "Builder's Helmet",
"Hats_144_F": "Aristocrat's Top hat",
"Hats_145_F": "Closed night vision device",
"Hats_146_F": "Open night vision device",
"Hair_0_F": "Under zero",
"Hair_1_F": "Short with bangs to the right",
"Hair_2_F": "Short with bangs to the left",
"Hair_3_F": "Pigtails",
"Hair_4_F": "Short with a Ponytail",
"Hair_5_F": "Curly Sue",
"Hair_6_F": "Dreadlocks",
"Hair_7_F": "Square",
"Hair_8_F": "Hawk",
"Hair_9_F": "Back to USSA",
"Hair_10_F": "Long bob",
"Hair_11_F": "Stacked bun",
"Hair_12_F": "Pixie",
"Hair_13_F": "Shaved temples",
"Hair_14_F": "Geisha",
"Hair_15_F": "Wavy Bob",
"Hair_16_F": "Beauty",
"Hair_17_F": "Bun",
"Hair_18_F": "Flapper bob",
"Hair_19_F": "Tight Knot",
"Hair_20_F": "Dandelion",
"Hair_21_F": "Explosion",
"Hair_22_F": "Knot with dreadlocks",
"Hair_23_F": "Rustic",
"Hair_24_F": "Night vision device",
"Hair_25_F": "Chipped pigtails",
"Hair_26_F": "Pigtails-leaves",
"Hair_27_F": "Pigtails-zigzags",
"Hair_28_F": "Ponytails with bangs",
"Hair_29_F": "Pigtails-waves",
"Hair_30_F": "Pigtails-curls",
"Hair_31_F": "Bangs-roller",
"Hair_32_F": "Disheveled comb back",
"Hair_33_F": "Trimmed comb back",
"Hair_34_F": "Trimmed comb sideways",
"Hair_35_F": "Spiked Mohawk",
"Hair_36_F": "Bandana and pigtails",
"Hair_37_F": "Chelsea",
"Hair_38_F": "Stylist",
"Hair_39_F": "Short with bangs to the right",
"Hair_40_F": "Short with bangs to the left",
"Hair_41_F": "Pigtails",
"Hair_42_F": "Short with a ponytail",
"Hair_43_F": "Curly Sue",
"Hair_44_F": "Dreadlocks",
"Hair_45_F": "Square",
"Hair_46_F": "Hawk",
"Hair_47_F": "Back to USSA",
"Hair_48_F": "Long bob",
"Hair_49_F": "Stacked bun",
"Hair_50_F": "Pixie",
"Hair_51_F": "Shaved Temples",
"Hair_52_F": "Geisha",
"Hair_53_F": "Wavy bob",
"Hair_54_F": "Beauty",
"Hair_55_F": "Bun",
"Hair_56_F": "Flapper bob",
"Hair_57_F": "Tight knot",
"Hair_58_F": "Dandelion",
"Hair_59_F": "Explosion",
"Hair_60_F": "Knot with dreadlocks",
"Hair_61_F": "Rustic",
"Hair_62_F": "Chipped pigtails",
"Hair_63_F": "Pigtails-leaves",
"Hair_64_F": "Pigtails-zigzags",
"Hair_65_F": "Ponytails with bangs",
"Hair_66_F": "Pigtails-waves",
"Hair_67_F": "Pigtails-curls",
"Hair_68_F": "Bangs-roller",
"Hair_69_F": "Disheveled comb back",
"Hair_70_F": "Trimmed comb back",
"Hair_71_F": "Trimmed comb sideways",
"Hair_72_F": "Spiked Mohawk",
"Hair_73_F": "Bandana and pigtails",
"Hair_74_F": "Chelsea",
"Hair_75_F": "Stylist",
"Hair_76_F": "Laid",
"Hair_77_F": "Bangs on the side",
"Hair_78_F": "Fashionable",
"Bracelets_0_F": "Gold bracelet-snake",
"Bracelets_1_F": "Diamond bracelet",
"Bracelets_2_F": "Gold flat bracelet",
"Bracelets_3_F": "Gold Bracelet 'Le Chien'",
"Bracelets_4_F": "Gold bracelet",
"Bracelets_5_F": "Gold Openwork Bracelet",
"Bracelets_6_F": "Gold relief bracelet",
"Bracelets_7_F": "Light bracelet",
"Bracelets_8_F": "Heavy bracelet",
"Bracelets_9_F": "Rectangular bracelet",
"Bracelets_10_F": "Bracelet with skulls",
"Bracelets_11_F": "Wide bracelet",
"Bracelets_12_F": "Chains with skulls",
"Bracelets_13_F": "Bracelet with spikes",
"Bracelets_14_F": "Bracelet",
"Watches_0_F": "-",
"Watches_1_F": "-",
"Watches_2_F": "Stylish",
"Watches_3_F": "CaCA Di Lusso",
"Watches_4_F": "Didier Sachs Mignon",
"Watches_5_F": "iFruit Link",
"Watches_6_F": "iFruit Tech",
"Watches_7_F": "Le Chien Marquise",
"Watches_8_F": "Fufu Jeunesse",
"Watches_9_F": "Anna Rex Prestige",
"Watches_10_F": "iFruit Snap",
"Watches_11_F": "Silver Braided Bracelet",
"Watches_12_F": "Silver bracelet with thick weave",
"Watches_13_F": "Silver bracelet with inserts",
"Watches_14_F": "Silver bracelet with pearls",
"Watches_15_F": "Silver bracelet wide",
"Watches_16_F": "Bracelet with beads",
"Watches_17_F": "Bracelet with spikes",
"Watches_18_F": "Wristband",
"Watches_19_F": "Classic",
"Watches_20_F": "Business",
"Watches_21_F": "Status",
"Watches_22_F": "Classic silver",
"Watches_23_F": "Compact classic",
"Watches_24_F": "Mechanical",
"Watches_25_F": "Casual",
"Watches_26_F": "Large classic",
"Watches_27_F": "SASS",
"Ears_0_F": "Headset №1",
"Ears_1_F": "Headset №2",
"Ears_2_F": "Headset №3",
"Ears_3_F": "Platinum pendulums",
"Ears_4_F": "Golden Pendulums",
"Ears_5_F": "With round diamond",
"Ears_6_F": "Diamonds",
"Ears_7_F": "Cascades",
"Ears_8_F": "Totems",
"Ears_9_F": "Diamond Chains",
"Ears_10_F": "Emerald Chains",
"Ears_11_F": "Sun Drops",
"Ears_12_F": "Diamond Earrings",
"Ears_13_F": "Green Hoop Earrings",
"Ears_14_F": "Thick Hoop Earrings",
"Ears_15_F": "Classic Hoop Earrings",
"Ears_16_F": "Earrings 'F'",
"Ears_17_F": "Branded Earrings'",
"Ears_18_F": "Gold Earrings",
"Ears_19_F": "Earrings 'Cards'",
"Ears_20_F": "Earrings 'Playing Dice'",
"Ears_21_F": "Earrings 'Chip'",
"Hats_0_M": "Protective headphones",
"Hats_1_M": "Paper cap",
"Hats_2_M": "Gangster Hat",
"Hats_3_M": "Panama Free",
"Hats_4_M": "LS Cap",
"Hats_5_M": "Youth hat",
"Hats_6_M": "Nostalgia cap",
"Hats_7_M": "Hooligan cap",
"Hats_8_M": "-",
"Hats_9_M": "Chess cap with visor backwards",
"Hats_10_M": "Chess cap with visor forward",
"Hats_11_M": "-",
"Hats_12_M": "Mafia hat",
"Hats_13_M": "Cowboy hat",
"Hats_14_M": "Bandana",
"Hats_15_M": "Headphones Beat Off",
"Hats_16_M": "Western MC Helmet",
"Hats_17_M": "Open Helmet",
"Hats_18_M": "Closed Motorcycle Helmet",
"Hats_19_M": "Flight headset",
"Hats_20_M": "Forest Panama",
"Hats_21_M": "Mexican hat",
"Hats_22_M": "New Year's hat",
"Hats_23_M": "Elf hat and ears",
"Hats_24_M": "Horns",
"Hats_25_M": "Hat The Godfather",
"Hats_26_M": "Bowler Hat",
"Hats_27_M": "Magician's Hat",
"Hats_28_M": "Freelancer Hat",
"Hats_29_M": "Elegant Hat",
"Hats_30_M": "Don Juan Hat",
"Hats_31_M": "Patriot Hat",
"Hats_32_M": "Patriot's Hat",
"Hats_33_M": "Patriot's High Hat",
"Hats_34_M": "Patriot's hat",
"Hats_35_M": "Decoration of a novice patriot",
"Hats_36_M": "Patriot horns",
"Hats_37_M": "Cap with beer",
"Hats_38_M": "Helmet of a real pilot",
"Hats_39_M": "Bulletproof helmet",
"Hats_40_M": "Herringbone hat",
"Hats_41_M": "Hat Cherry on the cake",
"Hats_42_M": "Elf hat",
"Hats_43_M": "Home hat",
"Hats_44_M": "Naughty cap",
"Hats_45_M": "Naughty cap with a visor back",
"Hats_46_M": "Police cap",
"Hats_47_M": "Darkened pilot's helmet",
"Hats_48_M": "Off-road glossy helmet",
"Hats_49_M": "Off-road matte helmet",
"Hats_50_M": "Biker matte Helmet",
"Hats_51_M": "Motorcycle matte mirror Helmet",
"Hats_52_M": "Motorcycle glossy helmet",
"Hats_53_M": "Biker glossy Mirror Helmet",
"Hats_54_M": "FAM cap",
 "Hats_55_M": "Broker cap",
"Hats_56_M": "Cap 'Cagnetica'",
"Hats_57_M": "Astronaut",
"Hats_58_M": "Cap with fabric insert",
"Hats_59_M": "Open helmet with protection",
"Hats_60_M": "Military cap with visor",
"Hats_61_M": "Hat with ribbon",
"Hats_62_M": "Closed motorcycle helmet",
"Hats_63_M": "Winter military cap",
"Hats_64_M": "Checkered hat",
"Hats_65_M": "Cap 'SecuroServ'",
"Hats_66_M": "Cap 'SecuroServ' with a visor back",
"Hats_67_M": "Open glossy motorcycle helmet",
"Hats_68_M": "Open matte motorcycle helmet",
"Hats_69_M": "Open mirror motorcycle helmet",
"Hats_70_M": "Open Motorcycle helmet",
"Hats_71_M": "Open Matte mirror Helmet",
"Hats_72_M": "Open Motorcycle Helmet",
"Hats_73_M": "Closed Retro Helmet",
"Hats_74_M": "Open Retro Helmet",
"Hats_75_M": "Faggio Helmet",
"Hats_76_M": "Cap 'ATOMIC'",
"Hats_77_M": "Cap 'On style'",
"Hats_78_M": "Closed Helmet DC",
"Hats_79_M": "Open helmet DC",
"Hats_80_M": "Golden closed helmet DC",
"Hats_81_M": "Golden open helmet DC",
"Hats_82_M": "Closed motorcycle helmet",
"Hats_83_M": "Denim hat",
"Hats_84_M": "Helmet with spikes",
"Hats_85_M": "Biker helmet",
"Hats_86_M": "Biker helmet with visor",
"Hats_87_M": "Biker helmet with long spikes",
"Hats_88_M": "Biker helmet with spikes",
"Hats_89_M": "Helmet combat",
"Hats_90_M": "Chrome helmet",
"Hats_91_M": "Neon closed helmet",
"Hats_92_M": "Neon open helmet",
"Hats_93_M": "Stunt helmet",
"Hats_94_M": "Panama lightweight",
"Hats_95_M": "Hat with a wide insert",
"Hats_96_M": "Cap 'Bigness'",
"Hats_97_M": "Hat 'Herringbone'",
"Hats_98_M": "Hat with mistletoe",
"Hats_99_M": "New Year's hat with a long bubon",
"Hats_100_M": "New Year's hat with ears",
"Hats_101_M": "Horns",
"Hats_102_M": "Ordinary cap",
"Hats_103_M": "Camouflage cap",
"Hats_104_M": "Camouflage panama hat",
"Hats_105_M": "Camouflage cowboy hat",
"Hats_106_M": "Camouflage beret",
"Hats_107_M": "Military commander's cap",
"Hats_108_M": "Camouflage hat with visor",
"Hats_109_M": "H&L cap with visor forward",
"Hats_110_M": "H&L cap with visor back",
"Hats_111_M": "Pilot's helmet",
"Hats_112_M": "Military helmet",
"Hats_113_M": "General's cap",
"Hats_114_M": "Pilot's cap",
"Hats_115_M": "Helmet mask",
"Hats_116_M": "Helmet with 2 lenses №1",
"Hats_117_M": "Helmet with 2 lenses №2",
"Hats_118_M": "Helmet with 4 lenses №1",
"Hats_119_M": "Helmet with 4 lenses №2",
"Hats_120_M": "Long hat",
"Hats_121_M": "-",
"Hats_122_M": "EMS cap",
"Hats_123_M": "Closed police helmet",
"Hats_124_M": "Open police helmet",
"Hats_125_M": "Closed translucent police helmet",
"Hats_126_M": "Open translucent police helmet",
"Hats_127_M": "Open transparent motorcycle helmet",
"Hats_128_M": "Closed transparent motorcycle helmet",
"Hats_129_M": "Helmet from a spacesuit",
"Hats_130_M": "Burger Shot cap, with visor forward",
"Hats_131_M": "Burger Shot cap, with visor back",
"Hats_132_M": "Panama 'TacoBomb'",
"Hats_133_M": "Helmet from an astronaut's spacesuit",
"Hats_134_M": "Helmet from a submariner's spacesuit",
"Hats_135_M": "Cap 'Diamond', with visor forward",
"Hats_136_M": " Cap 'Diamond', with visor back",
"Hats_137_M": "Helmet 'LSFD'",
"Hats_138_M": "Helmet 'LSFD', with glasses",
"Hats_139_M": "Cap 'BugStars', with visor forward",
"Hats_140_M": "'BugStats' cap, with visor back",
"Hats_141_M": "Protective helmet with glasses",
"Hats_142_M": "Juicy cap",
"Hats_143_M": "Juicy cap with a visor back",
"Hats_144_M": "Gruppe Sechs Helmet",
"Hats_145_M": "Builder's Helmet",
"Hats_146_M": "Aristocrat's Top hat",
"Hats_147_M": "Closed Night Vision device",
"Hats_148_M": "Outdoor night vision device",
"Hair_0_M": "Bald",
"Hair_1_M": "Short haircut",
"Hair_2_M": "Canadian",
"Hair_3_M": "Undercoat",
"Hair_4_M": "Classic",
"Hair_5_M": "Agent 007",
"Hair_6_M": "Stylish Cook",
"Hair_7_M": "Classic",
"Hair_8_M": "Dreadlocks back",
"Hair_9_M": "Male",
"Hair_10_M": "Ordinariness",
"Hair_11_M": "High quiff",
"Hair_12_M": "Half-box",
"Hair_13_M": "Bob male",
"Hair_14_M": "Dreadlocks",
"Hair_15_M": "Jesus",
"Hair_16_M": "Brutal curls",
"Hair_17_M": "Graduated square",
"Hair_18_M": "Intelligent",
"Hair_19_M": "Ordinary",
"Hair_20_M": "Romantic chic",
"Hair_21_M": "Italian macho",
"Hair_22_M": "Rustic",
"Hair_23_M": "Night vision device",
"Hair_24_M": "Dreadlocks",
"Hair_25_M": "Ja-dreadlocks",
"Hair_26_M": "Dangerous dreadlocks",
"Hair_27_M": "La-dreadlocks",
"Hair_28_M": "Safe dreadlocks",
"Hair_29_M": "Do-dreadlocks",
"Hair_30_M": "High platform",
"Hair_31_M": "Style",
"Hair_32_M": "Quiff",
"Hair_33_M": "Undercoat on the side",
"Hair_34_M": "Mohawk",
"Hair_35_M": "Disheveled",
"Hair_36_M": "Elongated",
"Hair_37_M": "Military",
"Hair_38_M": "Canadian",
"Hair_39_M": "Undercoat",
"Hair_40_M": "Classic",
"Hair_41_M": "Agent 007",
"Hair_42_M": "Stylish Cook",
"Hair_43_M": "Real classic",
"Hair_44_M": "Dreadlocks back",
"Hair_45_M": "Male",
"Hair_46_M": "Everyday",
"Hair_47_M": "High quiff",
"Hair_48_M": "Half-box",
"Hair_49_M": "Male bob",
"Hair_50_M": "Dreadlocks",
"Hair_51_M": "Jesus",
"Hair_52_M": "Brutal curls",
"Hair_53_M": "Graduated square",
"Hair_54_M": "Intelligent",
"Hair_55_M": "Ordinary",
"Hair_56_M": "Romantic chic",
"Hair_57_M": "Italian macho",
"Hair_58_M": "Rustic",
"Hair_59_M": "Dreadlocks",
"Hair_60_M": "Ja-dreadlocks",
"Hair_61_M": "Dangerous dreadlocks",
"Hair_62_M": "La-Dreadlocks",
"Hair_63_M": "Safe dreadlocks",
"Hair_64_M": "Pre-dreadlocks",
"Hair_65_M": "High platform",
"Hair_66_M": "Style",
"Hair_67_M": "Quiff",
"Hair_68_M": "Undercoat on the side",
"Hair_69_M": "Mohawk",
"Hair_70_M": "Disheveled",
"Hair_71_M": "Elongated",
"Hair_72_M": "Playground",
"Hair_73_M": "Army",
"Hair_74_M": "Elvis",
"Shoes_0_M": "High chess shoes",
"Shoes_1_M": "Low black sneakers",
"Shoes_2_M": "Low chess shoes",
"Shoes_3_M": "Leather loafers",
"Shoes_4_M": "High blue sneakers",
"Shoes_5_M": "Flip-flops with a narrow insert",
"Shoes_6_M": "Black slippers with socks",
"Shoes_7_M": "Sports sneakers",
"Shoes_8_M": "Sneakers for outdoor activities",
"Shoes_9_M": "Nike sneakers",
"Shoes_10_M": "Business shoes",
"Shoes_11_M": "Chess shoes",
"Shoes_12_M": "Winter boots",
"Shoes_13_M": "-",
"Shoes_14_M": "Stitched shoes",
"Shoes_15_M": "High boots",
"Shoes_16_M": "Hiking flip-flops",
"Shoes_17_M": "Elf shoes",
"Shoes_18_M": "Two-tone shoes",
"Shoes_19_M": "Tap shoes",
"Shoes_20_M": "Shoes with socks",
"Shoes_21_M": "Velvet shoes",
"Shoes_22_M": "High sneakers",
"Shoes_23_M": "Two-tone sneakers",
"Shoes_24_M": "Boots",
"Shoes_25_M": "Army boots",
"Shoes_26_M": "High sneakers",
"Shoes_27_M": "Worker's boots",
"Shoes_28_M": "High sneakers with spikes",
"Shoes_29_M": "Fabric sneakers",
"Shoes_30_M": "Two-tone Moccasins",
"Shoes_31_M": "Running shoes",
"Shoes_32_M": "High two-tone sneakers",
"Shoes_33_M": "-",
"Shoes_34_M": "-",
"Shoes_35_M": "Boots with laces",
"Shoes_36_M": "Stylish loafers",
"Shoes_37_M": "Cowboy boots",
"Shoes_38_M": "Cowboy shoes",
"Shoes_39_M": "Boots",
"Shoes_40_M": "Business shoes with socks",
"Shoes_41_M": "Loafers",
"Shoes_42_M": "Walking sneakers",
"Shoes_43_M": "Fashionable shoes",
"Shoes_44_M": "Cowboy boots with a clasp",
"Shoes_45_M": "Cowboy shoes with a clasp",
"Shoes_46_M": "Street sneakers",
"Shoes_47_M": "Street sneakers",
"Shoes_48_M": "High black sneakers",
"Shoes_49_M": "High yellow sneakers",
"Shoes_50_M": "High biker boots",
"Shoes_51_M": "Brogues",
"Shoes_52_M": "Farmer shoes",
"Shoes_53_M": "Punks",
"Shoes_54_M": "Oxfords",
"Shoes_55_M": "Sneakers with neon stripes",
"Shoes_56_M": "Insulated boots",
"Shoes_57_M": "Collared sneakers",
"Shoes_58_M": "Neon sneakers",
"Shoes_59_M": "Camouflage sneakers",
"Shoes_60_M": "Winter high boots",
"Shoes_61_M": "Insulated sneakers",
"Shoes_62_M": "Insulated boots",
"Shoes_63_M": "Military sneakers",
"Shoes_64_M": "Velcro sneakers",
"Shoes_65_M": "Winter boots elongated",
"Shoes_66_M": "Winter boots shortened",
"Shoes_67_M": "Fins",
"Shoes_68_M": "Slippers 'Matrix'",
"Shoes_69_M": "Rubber boots",
"Shoes_70_M": "Fishing boots high",
"Shoes_71_M": "Fishing boots shortened",
"Shoes_72_M": "Winter boots 'Dutiki'",
"Shoes_73_M": "Winter sneakers 'Dutiki'",
"Shoes_74_M": "Sneakers with Velcro with collar",
"Shoes_75_M": "Demi-season sneakers with a collar",
"Shoes_76_M": "Demi-season sneakers",
"Shoes_77_M": "Luminous sneakers",
"Shoes_78_M": "Shoes from the Robot suit",
"Shoes_79_M": "Biker boots",
"Shoes_80_M": "Shortened biker boots",
"Shoes_81_M": "Winter insulated boots with laces",
"Shoes_82_M": "Short winter insulated boots with laces",
"Shoes_83_M": "Socks 'Sledochki'",
"Shoes_84_M": "Knight boots high",
"Shoes_85_M": "Knight boots shortened",
"Shoes_86_M": "Knight boots",
"Shoes_87_M": "Clown boots",
"Shoes_88_M": "Snow Maiden boots",
"Shoes_89_M": "Winter sneakers",
"Shoes_90_M": "Winter ski boots",
"Shoes_91_M": "Super hero boots",
"Shoes_92_M": "Patterned Loafers",
"Shoes_93_M": "Men's sneakers winter",
"Shoes_95_M": "Walking moccasins",
"Shoes_96_M": "Dead Nikes",
"Shoes_97_M": "Outdoor Sneakers",
"Shoes_98_M": "Basketball Sneakers",
"Shoes_99_M": "Sports Sneakers",
"Shoes_100_M": "Sports Nikes",
"Shoes_101_M": "Gym Nikes",
"Shoes_102_M": "Leather shoes",
"Shoes_103_M": "Fashionable sneakers",
"Shoes_104_M": "Casual sneakers",
"Shoes_95_M": "Walking Moccasins",
"Shoes_0_F": "High-heeled shoes",
"Shoes_1_F": "Sports sneakers",
"Shoes_2_F": "Winter boots",
"Shoes_3_F": "Sneakers",
"Shoes_4_F": "Leather sneakers",
"Shoes_5_F": "Slates",
"Shoes_6_F": "Pointed toe shoes",
"Shoes_7_F": "Heeled shoes",
"Shoes_8_F": "Open-toed heeled shoes",
"Shoes_9_F": "Women's ankle boots",
"Shoes_10_F": "Aircrosses",
"Shoes_11_F": "Running shoes",
"Shoes_12_F": "-",
"Shoes_13_F": "Ballet Flats",
"Shoes_14_F": "Yoke",
"Shoes_15_F": "Sandals",
"Shoes_16_F": "Summer Flip-flops",
"Shoes_17_F": "Elf Shoes",
"Shoes_18_F": "Office shoes",
"Shoes_19_F": "Club shoes",
"Shoes_20_F": "Leopard shoes",
"Shoes_21_F": "High boots",
"Shoes_22_F": "Shoes with fur heels",
"Shoes_23_F": "Night shoes",
"Shoes_24_F": "Strict berets",
"Shoes_25_F": "Army berets",
"Shoes_26_F": "Welding berets",
"Shoes_27_F": "Light sneakers",
"Shoes_28_F": "Light sneakers with symbols",
"Shoes_29_F": "Classic shoes",
"Shoes_30_F": "High-heeled shoes with a clasp",
"Shoes_31_F": "Velcro sneakers",
"Shoes_32_F": "Fashionable sneakers",
"Shoes_33_F": "Sneakers with insulation",
"Shoes_34_F": "-",
"Shoes_35_F": "-",
"Shoes_36_F": "Leather boots",
"Shoes_37_F": "Loafers with a chain",
"Shoes_38_F": "Cowboy boots",
"Shoes_39_F": "Cowboy shoes",
"Shoes_40_F": "Suede boots",
"Shoes_41_F": "Shoes with thin stilettos with Velcro",
"Shoes_42_F": "Shoes with thin stilettos",
"Shoes_43_F": "High-heeled shoes",
"Shoes_44_F": "Bee Shoes",
"Shoes_45_F": "Wild West Boots",
"Shoes_46_F": "Wild West Shoes",
"Shoes_47_F": "Wrestling Sneakers",
"Shoes_48_F": "Protective Wrestling Shoes",
"Shoes_49_F": "Running shoes",
"Shoes_50_F": "Running shoes",
"Shoes_51_F": "Horse boots",
"Shoes_52_F": "Farmer boots",
"Shoes_53_F": "Farmer boots",
"Shoes_54_F": "Zip boots",
"Shoes_55_F": "Zip shoes",
"Shoes_56_F": "Black cowboy boots",
"Shoes_57_F": "Black cowboy shoes",
"Shoes_58_F": "Sneakers with neon stripes",
"Shoes_59_F": "Rustic shoes",
"Shoes_60_F": "Stylish sneakers",
"Shoes_61_F": "Luminous slippers",
"Shoes_62_F": "Camouflage sneakers",
"Shoes_63_F": "Boots winter",
"Shoes_64_F": "Winter sneakers",
"Shoes_65_F": "Military boots",
"Shoes_66_F": "Military sneakers",
"Shoes_67_F": "Sneakers with a collar",
"Shoes_68_F": "Winter boots",
"Shoes_69_F": "Fur boots",
"Shoes_70_F": "Fins",
"Shoes_71_F": "Slippers 'Matrix'",
"Shoes_72_F": "Cowboy boots",
"Shoes_73_F": "High safety boots",
"Shoes_74_F": "Safety boots",
"Shoes_75_F": "High safety shoes",
"Shoes_76_F": "Safety shoes",
"Shoes_77_F": "High boots",
"Shoes_78_F": "Running shoes",
"Shoes_79_F": "Hiking sneakers with a collar",
"Shoes_80_F": "Hiking sneakers",
"Shoes_81_F": "Luminous sneakers",
"Shoes_82_F": "Running sneakers",
"Shoes_83_F": "Fire boots",
"Shoes_84_F": "Fire boots",
"Shoes_85_F": "Factory boots",
"Shoes_86_F": "Factory boots",
"Shoes_87_F": "Socks",
"Shoes_88_F": "Knight high boots",
"Shoes_89_F": "Rustic knight",
"Shoes_90_F": "Rustic boots",
"Shoes_91_F": "Clown boots",
"Shoes_92_F": "Snow Maiden boots",
"Shoes_93_F": "Sneakers running shoes with a collar",
"Shoes_94_F": "Shoes from the 'Astronaut' costume",
"Shoes_95_F": "Super hero shoes",
"Shoes_96_F": "Basketball sneakers with a collar",
"Shoes_97_F": "Basketball sneakers",
"Shoes_98_F": "Christmas sneakers",
"Shoes_99_F": "Light sneakers",
"Accessories_0_F": "-",
"Accessories_1_F": "Gold earrings",
"Accessories_2_F": "Gold earrings №2",
"Accessories_3_F": "Black armband",
"Accessories_4_F": "Black and white bracelets",
"Accessories_5_F": "Armband",
"Accessories_6_F": "Gold pendant",
"Accessories_7_F": "Heart chain",
"Accessories_8_F": "-",
"Accessories_9_F": "White scarf",
"Accessories_10_F": "Wristbands",
"Accessories_11_F": "Chain with pendants",
"Accessories_12_F": "Pearl necklace and bracelet",
"Accessories_13_F": "Polka dot scarf",
"Accessories_14_F": "Pearl bracelet",
"Accessories_15_F": "Red scarf",
"Accessories_16_F": "Gas mask filter",
"Accessories_17_F": "Colored scarf",
"Accessories_18_F": "Colored scarf №2",
"Accessories_19_F": "Butterfly",
"Accessories_20_F": "Tie",
"Accessories_21_F": "Tie №2",
"Accessories_22_F": "Tie #3",
"Accessories_23_F": "Butterfly #2",
"Accessories_24_F": "Gas mask hose",
"Accessories_25_F": "Handcuffs",
"Accessories_26_F": "Tie #4",
"Accessories_27_F": "Tie #5",
"Accessories_28_F": "Tie №6",
"Accessories_29_F": "Chain",
"Accessories_30_F": "Chain with skull",
"Accessories_31_F": "Chain with skull №2",
"Accessories_32_F": "Chain with pendant №1",
"Accessories_33_F": "Chain with pendant №2",
"Accessories_34_F": "Chain with suspension №3",
"Accessories_35_F": "Chain with suspension №5",
"Accessories_36_F": "Chain with suspension №6",
"Accessories_37_F": "Chain with skull №3",
"Accessories_38_F": "Chain with mask",
"Accessories_39_F": "Chain with pendant №7",
"Accessories_40_F": "Chain with suspension №8",
"Accessories_41_F": "Chain with suspension №9",
"Accessories_42_F": "Chain with suspension №10",
"Accessories_43_F": "-",
"Accessories_44_F": "-",
"Accessories_45_F": "-",
"Accessories_46_F": "-",
"Accessories_47_F": "-",
"Accessories_48_F": "-",
"Accessories_49_F": "-",
"Accessories_50_F": "-",
"Accessories_51_F": "-",
"Accessories_52_F": "-",
"Accessories_53_F": "Chain #2",
"Accessories_54_F": "Chain #3",
"Accessories_55_F": "Chain #4",
"Accessories_56_F": "Chain #5",
"Accessories_57_F": "Chain #6",
"Accessories_58_F": "Chain #7",
"Accessories_59_F": "Chain #8",
"Accessories_60_F": "Chain #9",
"Accessories_61_F": "Chain #10",
"Accessories_62_F": "Chain #11",
"Accessories_63_F": "-",
"Accessories_64_F": "Chain #12",
"Accessories_65_F": "Chain #13",
"Accessories_66_F": "Chain #14",
"Accessories_67_F": "Chain #15",
"Accessories_68_F": "Chain #16",
"Accessories_69_F": "Chain #17",
"Accessories_70_F": "Chain #18",
"Accessories_71_F": "Chain #19",
"Accessories_72_F": "Chain #20",
"Accessories_73_F": "Chain #21",
"Accessories_74_F": "-",
"Accessories_75_F": "-",
"Accessories_76_F": "-",
"Accessories_77_F": "-",
"Accessories_78_F": "-",
"Accessories_79_F": "-",
"Accessories_80_F": "-",
"Accessories_81_F": "Chain with pendant №11",
"Accessories_82_F": "Chain with pendant №12",
"Accessories_83_F": "Scarf №6",
"Accessories_84_F": "Ponytail",
"Accessories_85_F": "Headphones",
"Accessories_86_F": "Tie and badge",
"Accessories_87_F": "Tie №7",
"Accessories_88_F": "Backpack",
"Accessories_89_F": "Chain with pendant №13",
"Accessories_90_F": "Chain with suspension №14",
"Accessories_91_F": "Chain with suspension №15",
"Accessories_92_F": "Chain with suspension №16",
"Accessories_93_F": "Ponytail №2",
"Accessories_94_F": "Headphones №2",
"Accessories_95_F": "Badge and badge 'IAA'",
"Accessories_96_F": "Phonendoscope",
"Accessories_97_F": "Badge 'Paramedic'",
"Accessories_98_F": "Badge 'IAA'",
"Accessories_99_F": "Chain with pendant №17",
"Accessories_100_F": "Chain with pendant №18",
"Accessories_101_F": "Chain with pendant №19",
"Accessories_102_F": "Additional pockets",
"Accessories_103_F": "Bell chain",
"Accessories_104_F": "Bell chain №2",
"Glasses_0_M": "-",
"Glasses_1_M": "Polaroid",
"Glasses_2_M": "Vance",
"Glasses_3_M": "Cat's eye",
"Glasses_4_M": "Panto stylish",
"Glasses_5_M": "Daring browliners",
"Glasses_6_M": "-",
"Glasses_7_M": "Dark waifarer",
"Glasses_8_M": "Aviator",
"Glasses_9_M": "Aspiring",
"Glasses_10_M": "Modern",
"Glasses_11_M": "Closed eyes",
"Glasses_12_M": "Fashionable aviator",
"Glasses_13_M": "Fashionista",
"Glasses_14_M": "-",
"Glasses_15_M": "Sports with yellow lenses",
"Glasses_16_M": "Sports",
"Glasses_17_M": "Serious browliner",
"Glasses_18_M": "Tishade",
"Glasses_19_M": "Glasses without lenses",
"Glasses_20_M": "Square without darkening",
"Glasses_21_M": "Stars",
"Glasses_22_M": "Patriotic",
"Glasses_23_M": "Shooting 'Shooters'",
"Glasses_24_M": "Vintage",
"Glasses_25_M": "Urban Ski",
"Glasses_26_M": "Scuba Mask",
"Glasses_27_M": "Surfers",
"Glasses_28_M": "Hipster",
"Glasses_29_M": "Luxury glasses",
"Accessories_0_M": "-",
"Accessories_1_M": "-",
"Accessories_2_M": "-",
"Accessories_3_M": "-",
"Accessories_4_M": "-",
"Accessories_5_M": "-",
"Accessories_6_M": "-",
"Accessories_7_M": "-",
"Accessories_8_M": "-",
"Accessories_9_M": "-",
"Accessories_10_M": "Tie",
"Accessories_11_M": "Butterfly",
"Accessories_12_M": "Tie #2",
"Accessories_13_M": "-",
"Accessories_14_M": "-",
"Accessories_15_M": "-",
"Accessories_16_M": "Chain",
"Accessories_17_M": "Chain #2",
"Accessories_18_M": "Tie #3",
"Accessories_19_M": "Tie #4",
"Accessories_20_M": "Tie #5",
"Accessories_21_M": "Tie #6",
"Accessories_22_M": "Bow Tie #2",
"Accessories_23_M": "Tie #7",
"Accessories_24_M": "Tie #8",
"Accessories_25_M": "Tie #9",
"Accessories_26_M": "Tie #10",
"Accessories_27_M": "Tie #11",
"Accessories_28_M": "Tie №12",
"Accessories_29_M": "Tie #13",
"Accessories_30_M": "Scarf",
"Accessories_31_M": "Scarf #2",
"Accessories_32_M": "Butterfly #3",
"Accessories_33_M": "Gas mask hose",
"Accessories_34_M": "Scarf #3",
"Accessories_35_M": "Scarf №4",
"Accessories_36_M": "Butterfly №4",
"Accessories_37_M": "Tie №14",
"Accessories_38_M": "Tie №15",
"Accessories_39_M": "Tie №16",
"Accessories_40_M": "Gas mask hose",
"Accessories_41_M": "Handcuffs",
"Accessories_42_M": "Chain with pendant",
"Accessories_43_M": "Chain with 'Skull' pendant",
"Accessories_44_M": "Chain with 'Mask' pendant",
"Accessories_45_M": "Chain with suspension №2",
"Accessories_46_M": "Chain with suspension №3",
"Accessories_47_M": "Chain with suspension №4",
"Accessories_48_M": "Chain with suspension №5",
"Accessories_49_M": "Chain with suspension №6",
"Accessories_50_M": "Chain with Skull pendant №2",
"Accessories_51_M": "Chain with Mask pendant №2",
"Accessories_52_M": "Chain with pendant №7",
"Accessories_53_M": "Chain with pendant №8",
"Accessories_54_M": "Chain with suspension №9",
"Accessories_55_M": "Chain with suspension №10",
"Accessories_56_M": "-",
"Accessories_57_M": "-",
"Accessories_58_M": "-",
"Accessories_59_M": "-",
"Accessories_60_M": "-",
"Accessories_61_M": "-",
"Accessories_62_M": "-",
"Accessories_63_M": "-",
"Accessories_64_M": "-",
"Accessories_65_M": "-",
"Accessories_66_M": "-",
"Accessories_67_M": "-",
"Accessories_68_M": "-",
"Accessories_69_M": "-",
"Accessories_70_M": "-",
"Accessories_71_M": "-",
"Accessories_72_M": "-",
"Accessories_73_M": "-",
"Accessories_74_M": "Chain #3",
"Accessories_75_M": "Chain #4",
"Accessories_76_M": "Chain #5",
"Accessories_77_M": "Chain #6",
"Accessories_78_M": "Chain #7",
"Accessories_79_M": "Chain #8",
"Accessories_80_M": "Chain #9",
"Accessories_81_M": "Chain #10",
"Accessories_82_M": "Chain #11",
"Accessories_83_M": "Chain #12",
"Accessories_84_M": "-",
"Accessories_85_M": "Chain #13",
"Accessories_86_M": "Chain #14",
"Accessories_87_M": "Chain #15",
"Accessories_88_M": "Chain #16",
"Accessories_89_M": "Chain #17",
"Accessories_90_M": "Chain #18",
"Accessories_91_M": "Chain #19",
"Accessories_92_M": "Chain #20",
"Accessories_93_M": "Chain #21",
"Accessories_94_M": "Chain #22",
"Accessories_95_M": "-",
"Accessories_96_M": "-",
"Accessories_97_M": "-",
"Accessories_98_M": "-",
"Accessories_99_M": "-",
"Accessories_100_M": "-",
"Accessories_101_M": "-",
"Accessories_102_M": "-",
"Accessories_103_M": "-",
"Accessories_104_M": "-",
"Accessories_105_M": "-",
"Accessories_106_M": "-",
"Accessories_107_M": "-",
"Accessories_108_M": "-",
"Accessories_109_M": "-",
"Accessories_110_M": "Chain with pendant №11",
"Accessories_111_M": "Chain with pendant №12",
"Accessories_112_M": "Scarf #5",
"Accessories_113_M": "Ponytail",
"Accessories_114_M": "Headphones",
"Accessories_115_M": "Tie #17",
"Accessories_116_M": "Tie #18",
"Accessories_117_M": "Tie #19",
"Accessories_118_M": "Butterfly №5",
"Accessories_119_M": "Chain with suspension №13",
"Accessories_120_M": "Chain with suspension №14",
"Accessories_121_M": "Chain with suspension №15",
"Accessories_122_M": "Chain with suspension №16",
"Accessories_123_M": "Ponytail #2",
"Accessories_124_M": "Headphones #2",
"Accessories_125_M": "Badge and badge 'IAA'",
"Accessories_126_M": "Phonendoscope",
"Accessories_127_M": "Badge 'Paramedic'",
"Accessories_128_M": "Badge 'IAA'",
"Accessories_129_M": "Chain with suspension №17",
"Accessories_130_M": "Chain with suspension №18",
"Accessories_131_M": "Chain with pendant №19",
"Accessories_132_M": "Tie around the neck",
"Accessories_133_M": "Additional pockets",
"Accessories_134_M": "Bell chain",
"Accessories_135_M": "Bell chain №2",
"Bracelets_0_M": "Light bracelet",
"Bracelets_1_M": "Heavy bracelet",
"Bracelets_2_M": "Rectangular bracelet",
"Bracelets_3_M": "Skull Bracelet",
"Bracelets_4_M": "Wide bracelet",
"Bracelets_5_M": "Skull Chains",
"Bracelets_6_M": "Studded Bracelet",
"Bracelets_7_M": "Bracelet",
"Tops_0_F": "T-shirt",
"Tops_1_F": "Jeans with pockets",
"Tops_2_F": "T-shirt with bare shoulder",
"Tops_3_F": "Jacket with a lock",
"Tops_4_F": "T-shirt without shoulders",
"Tops_5_F": "T-shirt without a belly",
"Tops_6_F": "Jacket with two buttons",
"Tops_7_F": "Business jacket",
"Tops_8_F": "Cropped wool jacket",
"Tops_9_F": "School shirt",
"Tops_10_F": "Olympic with stripes",
"Tops_11_F": "Sports jersey",
"Tops_12_F": "Checkered T-shirt",
"Tops_13_F": "Corset without shoulders",
"Tops_14_F": "Crocodile Polo",
"Tops_15_F": "-",
"Tops_16_F": "T-shirt for home",
"Tops_17_F": "Beach shirt",
"Tops_18_F": "Swimsuit",
"Tops_19_F": "New Year's T-shirt",
"Tops_20_F": "Business jacket with two buttons with insert",
"Tops_21_F": "Rustic dress",
"Tops_22_F": "Royal Corset",
"Tops_23_F": "Strict T-shirt",
"Tops_24_F": "Business jacket with two buttons office",
"Tops_25_F": "Open office jacket",
"Tops_26_F": "Pharaoh's blouse",
"Tops_27_F": "Shirt with pockets",
"Tops_28_F": "Dress vest",
"Tops_29_F": "Shirt with lapels",
"Tops_30_F": "Tight T-shirt",
"Tops_31_F": "Two-tone denim jacket",
"Tops_32_F": "T-shirt Leopard",
"Tops_33_F": "Top white",
"Tops_34_F": "Open camouflage jacket",
"Tops_35_F": "Cropped leather jacket",
"Tops_36_F": "Skull T-shirt",
"Tops_37_F": "Dress with flowers",
"Tops_38_F": "Fresh open shoulder T-shirt",
"Tops_39_F": "Part of a stuntman costume",
"Tops_40_F": "Summer open shoulder T-shirt",
"Tops_41_F": "Pilot jacket",
"Tops_42_F": "Combat jacket",
"Tops_43_F": "Military jacket",
"Tops_44_F": "New Year's jacket",
"Tops_45_F": "Pink jacket",
"Tops_46_F": "Army jacket",
"Tops_47_F": "Pilot jacket №2",
"Tops_48_F": "Police shirt",
"Tops_49_F": "Fresh T-shirt",
"Tops_50_F": "Sports jacket",
"Tops_51_F": "Magician's jacket",
"Tops_52_F": "Open crumpled jacket",
"Tops_53_F": "Crumpled closed jacket",
"Tops_54_F": "Closed sports jacket",
"Tops_55_F": "Closed leather jacket",
"Tops_56_F": "Casual shirt",
"Tops_57_F": "Open jacket",
"Tops_58_F": "Closed jacket",
"Tops_59_F": "Short jacket",
"Tops_60_F": "Waist-length jacket",
"Tops_61_F": "Fresh jacket",
"Tops_62_F": "Hooded jacket",
"Tops_63_F": "Outdoor jacket",
"Tops_64_F": "Suede coat",
"Tops_65_F": "Short fur jacket",
"Tops_66_F": "Jacket elegant",
"Tops_67_F": "Soft open shoulder T-shirt",
"Tops_68_F": "T-shirt with gold pattern",
"Tops_69_F": "Leather jacket 'Leather jacket'",
"Tops_70_F": "Closed coat with belt",
"Tops_71_F": "Diamond-shaped sweater",
"Tops_72_F": "Sports bomber",
"Tops_73_F": "Short-sleeved T-shirt",
"Tops_74_F": "Cropped top",
"Tops_75_F": "Long-sleeved sweater",
"Tops_76_F": "Long striped T-shirt",
"Tops_77_F": "Elongated jacket",
"Tops_78_F": "Hoodie with pockets",
"Tops_79_F": "Sweater with cropped sleeves",
"Tops_80_F": "Walking bomber",
"Tops_81_F": "Sports bomber with pockets",
"Tops_82_F": "-",
"Tops_83_F": "Pajama shirt with pocket",
"Tops_84_F": "Polo 'Andreas' №1",
"Tops_85_F": "Polo 'Andreas'№2",
"Tops_86_F": "Short sleeve shirt",
"Tops_87_F": "Jacket 'FB'",
"Tops_88_F": "Short sleeve T-shirt",
"Tops_89_F": "Motorcycle jacket",
"Tops_90_F": "Open jacket with buttons",
"Tops_91_F": "Closed jacket with buttons",
"Tops_92_F": "Open jacket with pockets ",
"Tops_93_F": "Closed jacket with pockets",
"Tops_94_F": "Open jacket with patterns",
"Tops_95_F": "Closed jacket with patterns",
"Tops_96_F": "Shirt with flowers",
"Tops_97_F": "Open checkered jacket",
"Tops_98_F": "Kimono shortened",
"Tops_99_F": "Pajama robe shortened",
"Tops_100_F": "Sleeveless T-shirt",
"Tops_101_F": "Swimsuit with straps",
"Tops_102_F": "Closed coat with belt",
"Tops_103_F": "Sweater tucked into pants",
"Tops_104_F": "Closed coat with buttons",
"Tops_105_F": "Summer blouse loose",
"Tops_106_F": "Sports outdoor jacket",
"Tops_107_F": "Long coat with buttons",
"Tops_108_F": "Closed Christmas jacket",
"Tops_109_F": "Pajama shirt",
"Tops_110_F": "Leather biker jacket",
"Tops_111_F": "Corset with lace",
"Tops_112_F": "Dress with patterns",
"Tops_113_F": "Dress with stripes",
"Tops_114_F": "Dress 'From Russia with love'",
"Tops_115_F": "Dress with green stripes",
"Tops_116_F": "Dress with white patterns",
"Tops_117_F": "Sleeveless T-shirt tucked in",
"Tops_118_F": "Sleeveless T-shirt",
"Tops_119_F": "Polo with collar",
"Tops_120_F": "Shirt with a deep neckline",
"Tops_121_F": "Closed shirt",
"Tops_122_F": "Closed jacket",
"Tops_123_F": "Striped jacket",
"Tops_124_F": "Blouse with a bow",
"Tops_125_F": "Street loose T-shirt with inserts",
"Tops_126_F": "Outdoor Loose T-shirt",
"Tops_127_F": "Jacket 'SecuroServ'",
"Tops_128_F": "T-shirt 'Liberty'",
"Tops_129_F": "T-shirt 'Liberty' tucked",
"Tops_130_F": "Two-tone shirt",
"Tops_131_F": "Sweatshirt 'Liberty'",
"Tops_132_F": "Shirt with birds",
"Tops_133_F": "Open jacket",
"Tops_134_F": "Vest",
"Tops_135_F": "Closed jacket with belt",
"Tops_136_F": "Sweatshirt tucked in",
"Tops_137_F": "Closed coat",
"Tops_138_F": "Olympic blue",
"Tops_139_F": "Long open coat",
"Tops_140_F": "Two-tone bomber",
"Tops_141_F": "Fresh T-shirt",
"Tops_142_F": "Striped shirt",
"Tops_143_F": "Closed cut-out jacket",
"Tops_144_F": "Racing bomber",
"Tops_145_F": "Racing bomber with insert",
"Tops_146_F": "Stunt shirt",
"Tops_147_F": "Sports jacket",
"Tops_148_F": "Leather jacket",
"Tops_149_F": "Nagasaki sweatshirt",
"Tops_150_F": "Closed army jacket",
"Tops_151_F": "Jacket with flag",
"Tops_152_F": "Cowboy stunt shirt",
"Tops_153_F": "Mechanic's jacket",
"Tops_154_F": "Biker vest",
"Tops_155_F": "Closed biker vest",
"Tops_156_F": "Closed vest with buttons",
"Tops_157_F": "Open biker vest",
"Tops_158_F": "Closed leather jacket",
"Tops_159_F": "Closed leather tank top",
"Tops_160_F": "Open bandit jacket",
"Tops_161_F": "Long T-shirt with insert",
"Tops_162_F": "Motorcycle leather jacket",
"Tops_163_F": "Open jacket with pockets",
"Tops_164_F": "Open down jacket",
"Tops_165_F": "Closed jacket",
"Tops_166_F": "Open Denim Jacket",
"Tops_167_F": "Open Denim Vest",
"Tops_168_F": "Tank Top",
"Tops_169_F": "Tank Top",
"Tops_170_F": "Rustic top",
"Tops_171_F": "Knotted Denim Shirt",
"Tops_172_F": "Glossy sweatshirt",
"Tops_173_F": "Leather beast",
"Tops_174_F": "Biker denim jacket",
"Tops_175_F": "Biker denim vest",
"Tops_176_F": "Biker leather jacket",
"Tops_177_F": "Biker leather vest",
"Tops_178_F": "Vest 'STFU'",
"Tops_179_F": "Closed vest",
"Tops_180_F": "Neon jacket",
"Tops_181_F": "Open biker vest",
"Tops_182_F": "Closed biker vest",
"Tops_183_F": "Open leather jacket",
"Tops_184_F": "Matte sweatshirt",
"Tops_185_F": "Striped shirt",
"Tops_186_F": "Long closed jacket",
"Tops_187_F": "Long open jacket",
"Tops_188_F": "Part of a bulletproof suit",
"Tops_189_F": "Closed long jacket",
"Tops_190_F": "Closed jacket with laces",
"Tops_191_F": "Open jacket with laces",
"Tops_192_F": "Striped Sweatshirt",
"Tops_193_F": "Open camouflage jacket",
"Tops_194_F": "Open long coat",
"Tops_195_F": "Guffy T-shirt",
"Tops_196_F": "New Year's Sweatshirt №1",
"Tops_197_F": "New Year's sweatshirt №2",
"Tops_198_F": "Game sweatshirt №1",
"Tops_199_F": "Game sweatshirt №2",
"Tops_200_F": "Jacket with Christmas trees №1",
"Tops_201_F": "Jacket with Christmas trees №2",
"Tops_202_F": "Bright jacket",
"Tops_203_F": "Luminous jacket",
"Tops_204_F": "Jacket with ",
"Tops_205_F": "Bright hooded sweatshirt",
"Tops_206_F": "Long hooded coat",
"Tops_207_F": "Tank top",
"Tops_208_F": "T-shirt 'Bigness' №1",
"Tops_209_F": "T-shirt 'Bigness' №2",
"Tops_210_F": "Camouflage tank top №1",
"Tops_211_F": "Camouflage tank top with hood",
"Tops_212_F": "Camouflage T-shirt №1",
"Tops_213_F": "Camouflage jacket closed",
"Tops_214_F": "Camouflage jacket with hood №1",
"Tops_215_F": "Camouflage jacket with hood №2",
"Tops_216_F": "Open camouflage jacket",
"Tops_217_F": "Camouflage vest with black front №1",
"Tops_218_F": "Blue Camouflage Vest",
"Tops_219_F": "Camouflage open jacket",
"Tops_220_F": "Camouflage Tank Top №3",
"Tops_221_F": "-",
"Tops_222_F": "Camouflage top",
"Tops_223_F": "-",
"Tops_224_F": "Camouflage T-shirt №2",
"Tops_225_F": "Camouflage T-shirt №3",
"Tops_226_F": "Camouflage T-shirt №4",
"Tops_227_F": "Closed fashion jacket",
"Tops_228_F": "Closed fashion jacket with hood",
"Tops_229_F": "-",
"Tops_230_F": "Military camouflage jacket",
"Tops_231_F": "Military Camouflage jacket with chevrons",
"Tops_232_F": "Camouflage jacket with short sleeves",
"Tops_233_F": "-",
"Tops_234_F": "Closed jacket №10",
"Tops_235_F": "Sweatshirt 'Class Of'",
"Tops_236_F": "T-shirt 'Ellipsis'",
"Tops_237_F": "Sports jacket 'Formula 1'",
"Tops_238_F": "Pilot's jacket with pockets",
"Tops_239_F": "Sports jacket",
"Tops_240_F": "Sports jacket unbuttoned",
"Tops_241_F": "-",
"Tops_242_F": "Long jacket with buttons",
"Tops_243_F": "Long jacket with buttons unbuttoned",
"Tops_244_F": "Short-sleeved shirt",
"Tops_245_F": "Short-sleeved shirt sleeves",
"Tops_246_F": "Striped polo",
"Tops_247_F": "-",
"Tops_248_F": "-",
"Tops_249_F": "Regular Polo",
"Tops_250_F": "Regular Polo",
"Tops_251_F": "Jacket №7",
"Tops_252_F": "Closed down jacket",
"Tops_253_F": "Patterned Sweatshirt",
"Tops_254_F": "-",
"Tops_255_F": "-",
"Tops_256_F": "Work jacket",
"Tops_257_F": "-",
"Tops_258_F": "Waist Shirt",
"Tops_259_F": "Anorak'Remy'without a hood",
"Tops_260_F": "-",
"Tops_261_F": "Anorak 'Remy' with a hood",
"Tops_262_F": "Light jacket",
"Tops_263_F": "Motorcycle racing jacket",
"Tops_264_F": "Multicolored sweatshirt",
"Tops_265_F": "Jacket with panthers",
"Tops_266_F": "Jacket 'Blogueurs'",
"Tops_267_F": "Jacket with buttons",
"Tops_268_F": "Sweatshirt with drawings",
"Tops_269_F": "Shirt with a pattern",
"Tops_270_F": "Open jacket with panthers",
"Tops_271_F": "Jacket 'Blogueurs' without hood",
"Tops_272_F": "Jacket 'Blogueurs' with hood",
"Tops_273_F": "Closed jacket with a strap",
"Tops_274_F": "Jacket in a circle",
"Tops_275_F": "Open jacket in a circle",
"Tops_276_F": "Closed jacket with a target",
"Tops_277_F": "Open jacket with pockets",
"Tops_278_F": "Multi-colored open jacket",
"Tops_279_F": "-",
"Tops_280_F": "T-shirt with a cutout and a shortened sleeve",
"Tops_281_F": "Fitted T-shirt with a cutout",
"Tops_282_F": "Motorcycle jacket №6",
"Tops_283_F": "Low-cut T-shirt",
"Tops_284_F": "-",
"Tops_285_F": "Jacket with a neck",
"Tops_286_F": "Fitted T-shirt",
"Tops_287_F": "-",
"Tops_288_F": "Cyborg jacket",
"Tops_289_F": "Knight jacket",
"Tops_290_F": "Part of the alien costume'",
"Tops_291_F": "Robot jacket",
"Tops_292_F": "Jacket 'Benedict' №1",
"Tops_293_F": "Jacket 'Benedict' №2",
"Tops_294_F": "Sweatshirt 'Burger-Shot'",
"Tops_295_F": "Long T-shirt 'Burger'",
"Tops_296_F": "Astronaut Jacket",
"Tops_297_F": "Jacket with blood",
"Tops_298_F": "Pilot Jacket",
"Tops_299_F": "Superhero Jacket",
"Tops_300_F": "Robot jacket",
"Tops_301_F": "Knitted jacket 'Burger-Shot'",
"Tops_302_F": "Part of the suit'Survivor'",
"Tops_303_F": "Fitted vest",
"Tops_303_F": "Part of the super hero costume",
"Tops_304_F": "Working open jacket",
"Tops_305_F": "Working closed jacket",
"Tops_306_F": "Jacket 'Bigness' №1",
"Tops_307_F": "Jacket 'Bigness' №2",
"Tops_308_F": "Jacket 'Bigness' №3",
"Tops_309_F": "Bomber walking",
"Tops_310_F": "Shirt 'Cosmos'",
"Tops_311_F": "Multicolored jacket 'Diamond' №1",
"Tops_312_F": "Multicolored jacket 'Diamond' №2",
"Tops_313_F": "Multicolored jacket 'Diamond' №3",
"Tops_314_F": "Multicolored jacket 'Diamond' №4",
"Tops_315_F": "Jacket with fur 'Sacapra'",
"Tops_316_F": "Jacket 'The Diamond' №1",
"Tops_317_F": "Jacket 'The Diamond' №2",
"Tops_318_F": "Sweatshirt 'Broker'",
"Tops_319_F": "Sweatshirt 'Bigness'",
"Tops_320_F": "Jacket 'Broker'",
"Tops_321_F": "T-shirt with a pattern",
"Tops_322_F": "Ball gown",
"Tops_323_F": "Dress 'Broker'",
"Tops_324_F": "T-shirt with airplanes",
"Tops_325_F": "Firefighter jacket №1",
"Tops_326_F": "Firefighter jacket №2",
"Tops_327_F": "Business long shirt",
"Tops_328_F": "Business long shirt №2",
"Tops_329_F": "Business short shirt",
"Tops_330_F": "Short business shirt №2",
"Tops_331_F": "Police uniform №1",
"Tops_332_F": "Office shirt",
"Tops_333_F": "Office shirt №2",
"Tops_334_F": "Office vest",
"Tops_335_F": "T-shirt with balls",
"Tops_336_F": "Jacket with protected sleeves",
"Tops_337_F": "Pixtro T-shirt",
"Tops_338_F": "Home T-shirt",
"Tops_339_F": "Business jacket",
"Tops_340_F": "Office jacket",
"Tops_341_F": "Sweatshirt 'HO-HO-HO'",
"Tops_342_F": "Tactical vest",
"Tops_343_F": "Military jacket",
"Tops_344_F": "Bomber",
"Tops_345_F": "Hooded jacket",
"Tops_346_F": "Bandit jacket'",
"Tops_370_F": "Lousy T-shirt",
"Tops_373_F": "Phillip Plein T-shirt",
"Torsos_0_F": "Gloves №1",
"Torsos_1_F": "Gloves №2",
"Torsos_2_F": "Gloves №3",
"Torsos_3_F": "Gloves №4",
"Torsos_4_F": "Gloves №5",
"Torsos_5_F": "Gloves №6",
"Torsos_6_F": "Gloves №7",
"Torsos_7_F": "Gloves №8",
"Torsos_8_F": "Gloves №9",
"Torsos_9_F": "Gloves №10",
"Torsos_10_F": "Gloves №11",
"Torsos_11_F": "Gloves №12",
"Torsos_12_F": "Gloves №13",
"Torsos_13_F": "Gloves №14",
"Torsos_14_F": "Gloves №15",
"Torsos_15_F": "Gloves №16",
"Torsos_16_F": "Long gloves №1",
"Torsos_17_F": "Motorcycle gloves №1",
"Torsos_18_F": "Motorcycle gloves №2",
"Torsos_19_F": "Gloves with open fingers №1",
"Torsos_20_F": "Semi-closed gloves №1",
"Torsos_21_F": "Semi-closed gloves №2",
"Torsos_22_F": "Semi-closed gloves №3",
"Torsos_23_F": "Semi-closed gloves №4",
"Torsos_24_F": "Semi-closed gloves №5",
"Torsos_25_F": "Semi-closed Gloves №6",
"Torsos_26_F": "Semi-closed gloves №7",
"Torsos_27_F": "Semi-closed gloves №8",
"Torsos_28_F": "Semi-closed gloves №9",
"Torsos_29_F": "Semi-closed gloves №10",
"Torsos_30_F": "Semi-closed gloves №11",
"Torsos_31_F": "Semi-closed gloves №12",
"Torsos_32_F": "Semi-closed Gloves №13",
"Torsos_33_F": "Closed Gloves №1",
"Torsos_34_F": "Closed gloves №2",
"Torsos_35_F": "Closed gloves №3",
"Torsos_36_F": "Closed gloves №4",
"Torsos_37_F": "Closed gloves №5",
"Torsos_38_F": "Closed gloves №6",
"Torsos_39_F": "Closed gloves №7",
"Torsos_40_F": "Closed gloves №8",
"Torsos_41_F": "Closed gloves №9",
"Torsos_42_F": "Closed gloves №10",
"Torsos_43_F": "Closed gloves №11",
"Torsos_44_F": "Closed gloves №12",
"Torsos_45_F": "Closed gloves №13",
"Torsos_46_F": "Closed gloves №14",
"Torsos_47_F": "Closed gloves №15",
"Torsos_48_F": "Closed gloves №16",
"Torsos_49_F": "Closed gloves №17",
"Torsos_50_F": "Closed gloves №18",
"Torsos_51_F": "Closed gloves №19",
"Torsos_52_F": "Closed gloves №20",
"Torsos_53_F": "Closed gloves №21",
"Torsos_54_F": "Closed gloves №22",
"Torsos_55_F": "Closed gloves №23",
"Torsos_56_F": "Closed gloves №24",
"Torsos_57_F": "Closed gloves №25",
"Torsos_58_F": "Closed gloves №26",
"Torsos_59_F": "Gloves with open fingers №2",
"Torsos_60_F": "Gloves with open fingers №3",
"Torsos_61_F": "Gloves with open fingers №4",
"Torsos_62_F": "Gloves with open fingers №5",
"Torsos_63_F": "Gloves with open fingers №6",
"Torsos_64_F": "Gloves with open fingers №7",
"Torsos_65_F": "Gloves with open fingers №8",
"Torsos_66_F": "Gloves with open fingers №9",
"Torsos_67_F": "Gloves with open fingers №10",
"Torsos_68_F": "Gloves with open fingers №11",
"Torsos_69_F": "Gloves with open fingers №12",
"Torsos_70_F": "Gloves with open fingers №13",
"Torsos_71_F": "Gloves with open fingers №14",
"Torsos_72_F": "Work gloves №1",
"Torsos_73_F": "Work gloves №2",
"Torsos_74_F": "Work gloves №3",
"Torsos_75_F": "Work Gloves №4",
"Torsos_76_F": "Work Gloves №5",
"Torsos_77_F": "Work Gloves №6",
"Torsos_78_F": "Work gloves №7",
"Torsos_79_F": "Work gloves №8",
"Torsos_80_F": "Work gloves №9",
"Torsos_81_F": "Work gloves №10",
"Torsos_82_F": "Work gloves №11",
"Torsos_83_F": "Work Gloves №12",
"Torsos_84_F": "Work gloves №13",
"Torsos_85_F": "Regular Gloves №1",
"Torsos_86_F": "Regular gloves №2",
"Torsos_87_F": "Ordinary gloves №3",
"Torsos_88_F": "Ordinary gloves №4",
"Torsos_89_F": "Ordinary gloves №5",
"Torsos_90_F": "Ordinary gloves №6",
"Torsos_91_F": "Ordinary gloves №7",
"Torsos_92_F": "Ordinary gloves №8",
"Torsos_93_F": "Ordinary gloves №9",
"Torsos_94_F": "Ordinary gloves №10",
"Torsos_95_F": "Ordinary gloves №11",
"Torsos_96_F": "Regular Gloves №12",
"Torsos_97_F": "Regular Gloves №13",
"Torsos_98_F": "Latex Gloves №1",
"Torsos_99_F": "Latex Gloves №2",
"Torsos_100_F": "Latex Gloves №3",
"Torsos_101_F": "Latex gloves №4",
"Torsos_102_F": "Latex gloves №5",
"Torsos_103_F": "Latex gloves №6",
"Torsos_104_F": "Latex gloves №7",
"Torsos_105_F": "Latex gloves №8",
"Torsos_106_F": "Latex gloves №9",
"Torsos_107_F": "Latex Gloves №10",
"Torsos_108_F": "Latex Gloves №11",
"Torsos_109_F": "Latex Gloves №12",
"Torsos_110_F": "Latex gloves №13",
"Torsos_111_F": "Protective gloves",
"Torsos_112_F": "Gloves from the Beast suit №1",
"Torsos_113_F": "Gloves from the Beast suit №2",
"Torsos_114_F": "Fabric gloves №1",
"Torsos_115_F": "Fabric gloves №2",
"Torsos_116_F": "Fabric gloves №3",
"Torsos_117_F": "Fabric gloves №4",
"Torsos_118_F": "Fabric gloves №5",
"Torsos_119_F": "Fabric gloves №6",
"Torsos_120_F": "Fabric gloves №7",
"Torsos_121_F": "Fabric gloves №8",
"Torsos_122_F": "Fabric gloves №9",
"Torsos_123_F": "Fabric gloves №10",
"Torsos_124_F": "Fabric gloves №11",
"Torsos_125_F": "Fabric gloves №12",
"Torsos_126_F": "Fabric gloves №13",
"Torsos_127_F": "Motorcycle №3",
"Torsos_128_F": "Motorcycle №4",
"Torsos_129_F": "-",
"Torsos_130_F": "-",
"Torsos_131_F": "-",
"Torsos_132_F": "Semi-closed gloves №14",
"Torsos_133_F": "Latex gloves №14",
"Torsos_134_F": "Fabric gloves №14",
"Torsos_135_F": "Gloves with open fingers №15",
"Torsos_136_F": "Work gloves №14",
"Torsos_137_F": "Regular gloves №14",
"Torsos_138_F": "Latex gloves №15",
"Torsos_139_F": "Semi-closed gloves №15",
"Torsos_140_F": "Closed gloves №27",
"Torsos_141_F": "Fabric gloves №15",
"Torsos_142_F": "Gloves with open fingers №15",
"Torsos_143_F": "Work gloves №15",
"Torsos_144_F": "Regular gloves №15",
"Torsos_145_F": "Latex Gloves №16",
"Torsos_146_F": "Semi-closed Gloves №16",
"Torsos_147_F": "Closed gloves №28",
"Torsos_148_F": "Fabric gloves №16",
"Torsos_149_F": "Gloves with open fingers №16",
"Torsos_150_F": "Work gloves №16",
"Torsos_151_F": "Regular gloves №16",
"Torsos_152_F": "Latex gloves №17",
"Torsos_153_F": "-",
"Torsos_154_F": "Semi-closed gloves №17",
"Torsos_155_F": "Closed gloves №29",
"Torsos_156_F": "Fabric gloves №17",
"Torsos_157_F": "Gloves with open fingers №17",
"Torsos_158_F": "Work gloves №17",
"Torsos_159_F": "Regular gloves №17",
"Torsos_160_F": "Latex gloves №18",
"Torsos_161_F": "-",
"Torsos_162_F": "Semi-closed gloves №18",
"Torsos_163_F": "Closed gloves №30",
"Torsos_164_F": "Fabric gloves №18",
"Torsos_165_F": "Gloves with open fingers №18",
"Torsos_166_F": "Work gloves №18",
"Torsos_167_F": "Regular gloves №18",
"Torsos_168_F": "Latex gloves №19",
"Torsos_169_F": "Military gloves №1",
"Torsos_170_F": "Military Gloves №2",
"Torsos_171_F": "Military Gloves №3",
"Torsos_172_F": "Military Gloves №4",
"Torsos_173_F": "Military Gloves №5",
"Torsos_174_F": "Military Gloves №6",
"Torsos_175_F": "Military gloves №7",
"Torsos_176_F": "Military gloves №8",
"Torsos_177_F": "Military gloves №9",
"Torsos_178_F": "Military gloves №10",
"Torsos_179_F": "Military gloves №11",
"Torsos_180_F": "Military gloves №12",
"Torsos_181_F": "Military gloves №13",
"Torsos_182_F": "Military gloves №14",
"Torsos_183_F": "Military gloves №15",
"Torsos_184_F": "Military gloves №16",
"Torsos_185_F": "Military Gloves №17",
"Torsos_186_F": "Military Gloves №18",
"Torsos_187_F": "Military Gloves №19",
"Torsos_188_F": "Military gloves №20",
"Torsos_189_F": "Military gloves №21",
"Torsos_190_F": "Military gloves №22",
"Torsos_191_F": "Military gloves №23",
"Torsos_192_F": "Military gloves №24",
"Torsos_193_F": "Military gloves №25",
"Torsos_194_F": "Military Gloves №26",
"Torsos_195_F": "Military gloves №27",
"Torsos_196_F": "Military gloves №28",
"Torsos_197_F": "Military gloves №29",
"Torsos_198_F": "Military Gloves №30",
"Torsos_199_F": "Military Gloves №31",
"Torsos_200_F": "Military Gloves №32",
"Torsos_201_F": "Military Gloves №33",
"Torsos_202_F": "Military Gloves №34",
"Torsos_203_F": "Military Gloves №35",
"Torsos_204_F": "Military gloves №36",
"Torsos_205_F": "Hands from the 'Monster' suit",
"Torsos_206_F": "Gloves from the 'Cosmonaut' suit №1",
"Torsos_207_F": "Gloves from the 'Cosmonaut' suit №2",
"Torsos_208_F": "Gloves from the Cosmonaut costume №3",
"Torsos_209_F": "Gloves from the super hero costume",
"Torsos_0_M": "Gloves №1",
"Torsos_1_M": "Gloves №2",
"Torsos_2_M": "Gloves №3",
"Torsos_3_M": "Gloves №4",
"Torsos_4_M": "Gloves №5",
"Torsos_5_M": "Gloves №6",
"Torsos_6_M": "Gloves №7",
"Torsos_7_M": "Gloves №8",
"Torsos_8_M": "Gloves №9",
"Torsos_9_M": "Gloves №10",
"Torsos_10_M": "Gloves №11",
"Torsos_11_M": "Gloves №12",
"Torsos_12_M": "Gloves №13",
"Torsos_13_M": "Gloves №14",
"Torsos_14_M": "Gloves №15",
"Torsos_15_M": "Gloves №16",
"Torsos_16_M": "Motorcycle gloves №1",
"Torsos_17_M": "Motorcycle gloves №2",
"Torsos_18_M": "Gloves with open fingers №1",
"Torsos_19_M": "Semi-closed gloves №1",
"Torsos_20_M": "Semi-closed gloves №2",
"Torsos_21_M": "Semi-closed gloves №3",
"Torsos_22_M": "Semi-closed gloves №4",
"Torsos_23_M": "Semi-closed gloves №5",
"Torsos_24_M": "Semi-closed gloves №6",
"Torsos_25_M": "Semi-closed gloves №7",
"Torsos_26_M": "Semi-closed Gloves №8",
"Torsos_27_M": "Semi-closed gloves №9",
"Torsos_28_M": "Semi-closed gloves №10",
"Torsos_29_M": "Semi-closed gloves №11",
"Torsos_30_M": "Closed gloves №1",
"Torsos_31_M": "Closed gloves №2",
"Torsos_32_M": "Closed gloves №3",
"Torsos_33_M": "Closed gloves №4",
"Torsos_34_M": "Closed gloves №5",
"Torsos_35_M": "Closed gloves №6",
"Torsos_36_M": "Closed gloves №7",
"Torsos_37_M": "Closed gloves №8",
"Torsos_38_M": "Closed gloves №9",
"Torsos_39_M": "Closed gloves №10",
"Torsos_40_M": "Closed gloves №11",
"Torsos_41_M": "Closed gloves №12",
"Torsos_42_M": "Closed gloves №13",
"Torsos_43_M": "Closed gloves №14",
"Torsos_44_M": "Closed gloves №15",
"Torsos_45_M": "Closed gloves №16",
"Torsos_46_M": "Closed gloves №17",
"Torsos_47_M": "Closed gloves №18",
"Torsos_48_M": "Closed gloves №19",
"Torsos_49_M": "Closed gloves №20",
"Torsos_50_M": "Closed gloves №21",
"Torsos_51_M": "Gloves with open fingers №2",
"Torsos_52_M": "Gloves with open fingers №3",
"Torsos_53_M": "Gloves with open fingers №4",
"Torsos_54_M": "Gloves with open fingers №5",
"Torsos_55_M": "Gloves with open fingers №4", 
"Torsos_54_M": "Gloves with open fingers №5", 
"Torsos_55_M": "Gloves with open fingers fingers №6",
"Torsos_56_M": "Gloves with open fingers №7",
"Torsos_57_M": "Gloves with open fingers №8",
"Torsos_58_M": "Gloves with open fingers №9",
"Torsos_59_M": "Gloves with open fingers №10",
"Torsos_60_M": "Gloves with open fingers №11",
"Torsos_61_M": "Gloves with open fingers №10", 
"Torsos_60_M": "Gloves with open fingers №11", 
"Torsos_61_M": "Gloves with open fingers fingers №12",
"Torsos_62_M": "Gloves with open fingers №13",
"Torsos_63_M": "Work gloves №1",
"Torsos_64_M": "Work gloves №2",
"Torsos_65_M": "Work gloves №3",
"Torsos_66_M": "Work gloves №4",
"Torsos_67_M": "Work gloves №5",
"Torsos_68_M": "Work gloves №6",
"Torsos_69_M": "Work gloves №7",
"Torsos_70_M": "Work gloves №8",
"Torsos_71_M": "Work gloves №9",
"Torsos_72_M": "Work gloves №10",
"Torsos_73_M": "Work gloves №11",
"Torsos_74_M": "Ordinary gloves №1",
"Torsos_75_M": "Ordinary gloves №2",
"Torsos_76_M": "Ordinary gloves №3",
"Torsos_77_M": "Ordinary gloves №4",
"Torsos_78_M": "Ordinary gloves №5",
"Torsos_79_M": "Ordinary gloves №6",
"Torsos_80_M": "Ordinary gloves №7",
"Torsos_81_M": "Ordinary gloves №8",
"Torsos_82_M": "Ordinary gloves №9",
"Torsos_83_M": "Regular Gloves №10",
"Torsos_84_M": "Regular Gloves №11",
"Torsos_85_M": "Latex Gloves №1",
"Torsos_86_M": "Latex Gloves №2",
"Torsos_87_M": "Latex Gloves №3",
"Torsos_88_M": "Latex gloves №4",
"Torsos_89_M": "Latex gloves №5",
"Torsos_90_M": "Latex gloves №6",
"Torsos_91_M": "Latex gloves №7",
"Torsos_92_M": "Latex gloves №8",
"Torsos_93_M": "Latex gloves №9",
"Torsos_94_M": "Latex Gloves №10",
"Torsos_95_M": "Latex Gloves №11",
"Torsos_96_M": "Protective gloves",
"Torsos_97_M": "Gloves from the 'Beast' suit №1",
"Torsos_98_M": "Gloves from the 'Beast' suit №2",
"Torsos_99_M": "Fabric gloves №1",
"Torsos_100_M": "Fabric gloves №2",
"Torsos_101_M": "Fabric gloves №3",
"Torsos_102_M": "Fabric gloves №4",
"Torsos_103_M": "Fabric gloves №5",
"Torsos_104_M": "Fabric gloves №6",
"Torsos_105_M": "Fabric gloves №7",
"Torsos_106_M": "Fabric gloves №8",
"Torsos_107_M": "Fabric gloves №9",
"Torsos_108_M": "Fabric gloves №10",
"Torsos_109_M": "Fabric gloves №11",
"Torsos_110_M": "Motorcycle №3",
"Torsos_111_M": "Motorcycle №4",
"Torsos_112_M": "-",
"Torsos_113_M": "-",
"Torsos_114_M": "-",
"Torsos_115_M": "Semi-closed Gloves №12",
"Torsos_116_M": "Closed gloves №22",
"Torsos_117_M": "Closed gloves №23",
"Torsos_118_M": "Gloves with open fingers №14",
"Torsos_119_M": "Work gloves №12",
"Torsos_120_M": "Regular gloves №12",
"Torsos_121_M": "Latex gloves №12",
"Torsos_122_M": "Semi-closed gloves №13",
"Torsos_123_M": "Closed gloves №24",
"Torsos_124_M": "Closed gloves №25",
"Torsos_125_M": "Gloves with open fingers №15",
"Torsos_126_M": "Work gloves №13",
"Torsos_127_M": "Regular gloves №13",
"Torsos_128_M": "Latex gloves №13",
"Torsos_129_M": "Semi-closed gloves №14",
"Torsos_130_M": "Closed gloves №26",
"Torsos_131_M": "Closed gloves №27",
"Torsos_132_M": "Gloves with open fingers №16",
"Torsos_133_M": "Work gloves №14",
"Torsos_134_M": "Regular gloves №14",
"Torsos_135_M": "Latex gloves №14",
"Torsos_136_M": "Military gloves №1",
"Torsos_137_M": "Military gloves №2",
"Torsos_138_M": "Military Gloves №3",
"Torsos_139_M": "Military Gloves №4",
"Torsos_140_M": "Military Gloves №5",
"Torsos_141_M": "Military Gloves №6",
"Torsos_142_M": "Military Gloves №7",
"Torsos_143_M": "Military gloves №8",
"Torsos_144_M": "Military gloves №9",
"Torsos_145_M": "Military gloves №10",
"Torsos_146_M": "Military gloves №11",
"Torsos_147_M": "Military gloves №12",
"Torsos_148_M": "Military gloves №13",
"Torsos_149_M": "Military gloves №14",
"Torsos_150_M": "Military gloves №15",
"Torsos_151_M": "Military gloves №16",
"Torsos_152_M": "Military gloves №17",
"Torsos_153_M": "Military gloves №18",
"Torsos_154_M": "Military gloves №19",
"Torsos_155_M": "Military gloves №20",
"Torsos_156_M": "Military gloves №21",
"Torsos_157_M": "Military gloves №22",
"Torsos_158_M": "Military gloves №23",
"Torsos_159_M": "Military gloves №24",
"Torsos_160_M": "Military Gloves №25",
"Torsos_161_M": "Military Gloves №26",
"Torsos_162_M": "Military gloves №27",
"Torsos_163_M": "Military gloves №28",
"Torsos_164_M": "Hands from the 'Monster' suit",
"Torsos_165_M": "Gloves from the Cosmonaut costume №1",
"Torsos_166_M": "Gloves from the Cosmonaut costume №1",
"Torsos_167_M": "Gloves from the Cosmonaut costume №1",
"Torsos_168_M": "Gloves from the super hero costume",
"Bags_0": "-",
"Bags_1": "Classic Backpack",
"Bags_2": "Classic Backpack",
"Bags_3": "Classic Backpack",
"Bags_4": "Classic Backpack",
"Bags_5": "Classic Backpack",
"Bags_6": "Classic Backpack",
"Bags_7": "Classic backpack",
"Bags_8": "Classic Backpack",
"Bags_9": "-",
"Bags_10": "Patriot backpack",
"Bags_11": "Patriot backpack", 
"Bags_12": "Patriot Backpack", 
"Bags_13": "Patriot backpack", 
"Bags_14": "Patriot backpack", 
"Bags_15": "Patriot backpack", 
"Bags_16": "Patriot Backpack", 
"Bags_17": "BackpackPatriot",
"Bags_18": "Patriot's backpack",
"Bags_19": "Classic backpack",
"Bags_20": "-",
"Bags_21": "Backpack with the flag of Finland",
"Bags_22": "Backpack with the flag of Finland",
"Bags_23": "Backpack with the flag of Finland",
"Bags_24": "Backpack with the flag of Finland",
"Bags_25": "Backpack with the flag of Finland",
"Bags_26": "Backpack with the flag of Finland",
"Bags_27": "Backpack with the flag of Finland",
"Bags_28": "Backpack with the flag of Finland",
"Bags_29": "Backpack with the flag of Finland",
"Bags_30": "-",
"Bags_31": "Plain cotton backpack",
"Bags_32": "Plain cotton backpack",
"Bags_33": "Plain cotton backpack",
"Bags_34": "Plain cotton backpack",
"Bags_35": "Plain cotton backpack",
"Bags_36": "Plain cotton backpack",
"Bags_37": "Plain cotton backpack",
"Bags_38": "Plain cotton backpack",
"Bags_39": "Plain cotton backpack",
"Bags_40": "Cotton bag",
"Bags_41": "Closed cotton bag",
"Bags_42": "-",
"Bags_43": "-",
"Bags_44": "Leather Bag",
"Bags_45": "Closed leather bag",
"Bags_46": "-",
"Bags_47": "-",
"Bags_48": "Classic backpack",
"Bags_49": "Patriot backpack",
"Bags_50": "Backpack with the flag of Finland",
"Bags_51": "Plain cotton backpack",
"Bags_52": "Two-tone cotton backpack",
"Bags_53": "Two-tone cotton backpack",
"Bags_54": "Two-tone cotton backpack",
"Bags_55": "Two-tone cotton backpack",
"Bags_56": "Two-tone cotton backpack",
"Bags_57": "Two-tone cotton backpack",
"Bags_58": "Two-tone cotton backpack",
"Bags_59": "Two-tone cotton backpack",
"Bags_60": "Two-tone cotton backpack",
"Bags_61": "Two-tone cotton backpack",
"Bags_62": "Classic backpack",
"Bags_63": "Classic backpack",
"Bags_64": "Patriot backpack",
"Bags_65": "Backpack with the flag of Finland",
"Bags_66": "Plain cotton backpack",
"Bags_67": "Patriot backpack",
"Bags_68": "Classic backpack",
"Bags_69": "Two-tone cotton backpack",
"Bags_70": "Backpack with the flag of India",
"Bags_71": "Backpack with the flag of India",
"Bags_72": "Backpack with the flag of India",
"Bags_73": "Backpack with the flag of India",
"Bags_74": "Backpack with the flag of India",
"Bags_75": "Backpack with the flag of India",
"Bags_76": "Backpack with the flag of India",
"Bags_77": "Backpack with the flag of India",
"Bags_78": "Backpack with the flag of India",
"Bags_79": "Backpack with the flag of India",
"Bags_80": "Backpack with the flag of India",
"Bags_81": "Leather bag",
"Bags_82": "Closed leather bag",
"Bags_83": "-",
"Bags_84": "-",
"Undershirts_0_F": "T-shirt №1",
"Undershirts_1_F": "T-shirt №2",
"Undershirts_2_F": "-",
"Undershirts_3_F": "-",
"Undershirts_4_F": "-",
"Undershirts_5_F": "T-shirt #3",
"Undershirts_6_F": "T-shirt #4",
"Undershirts_7_F": "-",
"Undershirts_8_F": "-",
"Undershirts_9_F": "-",
"Undershirts_10_F": "-",
"Undershirts_11_F": "Swimsuit top",
"Undershirts_12_F": "Cut-out T-shirt",
"Undershirts_13_F": "Corset №1",
"Undershirts_14_F": "-",
"Undershirts_15_F": "-",
"Undershirts_16_F": "T-shirt without straps",
"Undershirts_17_F": "-",
"Undershirts_18_F": "Part from New Year's costume №1",
"Undershirts_19_F": "Part from New Year's costume №2",
"Undershirts_20_F": "T-shirt №5",
"Undershirts_21_F": "T-shirt №6",
"Undershirts_22_F": "Corset №2",
"Undershirts_23_F": "Blouse №1",
"Undershirts_24_F": "Shirt №1",
"Undershirts_25_F": "Topic №1",
"Undershirts_26_F": "T-shirt №7",
"Undershirts_27_F": "Topic №2",
"Undershirts_28_F": "-",
"Undershirts_29_F": "T-shirt №8",
"Undershirts_30_F": "T-shirt №9",
"Undershirts_31_F": "T-shirt №10",
"Undershirts_32_F": "Vest №1",
"Undershirts_33_F": "Vest №2",
"Undershirts_34_F": "-",
"Undershirts_35_F": "-",
"Undershirts_36_F": "Work vest",
"Undershirts_37_F": "Shirt #2",
"Undershirts_38_F": "Shirt #3",
"Undershirts_39_F": "Shirt #4",
"Undershirts_40_F": "Shirt with vest #1",
"Undershirts_41_F": "Shirt with vest #2",
"Undershirts_42_F": "-",
"Undershirts_43_F": "-",
"Undershirts_44_F": "T-shirt №1",
"Undershirts_45_F": "T-shirt with gold pattern",
"Undershirts_46_F": "T-shirt with dark gold pattern №1",
"Undershirts_47_F": "T-shirt №11",
"Undershirts_48_F": "T-shirt №12",
"Undershirts_49_F": "T-shirt №13",
"Undershirts_50_F": "T-shirt with dark gold pattern №2",
"Undershirts_51_F": "T-shirt #2",
"Undershirts_52_F": "T-shirt #3",
"Undershirts_53_F": "T-shirt #14",
"Undershirts_54_F": "T-shirt #15",
"Undershirts_55_F": "T-shirt #16",
"Undershirts_56_F": "T-shirt #17",
"Undershirts_57_F": "T-shirt №4",
"Undershirts_58_F": "T-shirt №5",
"Undershirts_59_F": "T-shirt №6",
"Undershirts_60_F": "Topic №3",
"Undershirts_61_F": "T-shirt №18",
"Undershirts_62_F": "T-shirt №19",
"Undershirts_63_F": "T-shirt №20",
"Undershirts_64_F": "Shirt with buttons undone",
"Undershirts_65_F": "Shirt №5",
"Undershirts_66_F": "Jacket №1",
"Undershirts_67_F": "Jacket №2",
"Undershirts_68_F": "Corset №3",
"Undershirts_69_F": "T-shirt №21",
"Undershirts_70_F": "T-shirt №22",
"Undershirts_71_F": "T-shirt №23",
"Undershirts_72_F": "T-shirt №24",
"Undershirts_73_F": "T-shirt №25",
"Undershirts_74_F": "T-shirt №26",
"Undershirts_75_F": "Shirt №6",
"Undershirts_76_F": "Jacket №3",
"Undershirts_77_F": "Jacket №4",
"Undershirts_78_F": "T-shirt №27",
"Undershirts_79_F": "T-shirt №7",
"Undershirts_80_F": "T-shirt №8",
"Undershirts_81_F": "-",
"Undershirts_82_F": "Nagasaki T-shirt №1",
"Undershirts_83_F": "Nagasaki T-shirt №2",
"Undershirts_84_F": "Nagasaki T-shirt №3",
"Undershirts_85_F": "Nagasaki T-shirt №4",
"Undershirts_86_F": "T-shirt №28",
"Undershirts_87_F": "T-shirt №29",
"Undershirts_88_F": "T-shirt №30",
"Undershirts_89_F": "T-shirt №31",
"Undershirts_90_F": "T-shirt №32",
"Undershirts_91_F": "T-shirt №33",
"Undershirts_92_F": "T-shirt №34",
"Undershirts_93_F": "T-shirt #35",
"Undershirts_94_F": "T-shirt #36",
"Undershirts_95_F": "T-shirt #37",
"Undershirts_96_F": "-",
"Undershirts_97_F": "T-shirt №38",
"Undershirts_98_F": "T-shirt №39",
"Undershirts_99_F": "-",
"Undershirts_100_F": "T-shirt №40",
"Undershirts_101_F": "Shirt №7",
"Undershirts_102_F": "Jacket with shirt",
"Undershirts_103_F": "Jacket with jacket",
"Undershirts_104_F": "Shirt №8",
"Undershirts_105_F": "Bulletproof suit",
"Undershirts_106_F": "T-shirt 'Bigness' №1",
"Undershirts_107_F": "T-shirt 'Bigness' №2",
"Undershirts_108_F": "T-shirt 'Bigness' №3",
"Undershirts_109_F": "T-shirt 'Bigness' №4",
"Undershirts_110_F": "T-shirt 'Bigness' №5",
"Undershirts_111_F": "T-shirt 'Bigness' №6",
"Undershirts_112_F": "T-shirt 'Bigness' №7",
"Undershirts_113_F": "T-shirt 'Bigness' №8",
"Undershirts_114_F": "T-shirt 'Bigness' №9",
"Undershirts_115_F": "T-shirt 'Bigness'№10",
"Undershirts_116_F": "T-shirt 'Bigness' №11",
"Undershirts_117_F": "T-shirt 'Bigness' №12",
"Undershirts_118_F": "Pixel T-shirt №1",
"Undershirts_119_F": "Pixel T-shirt №2",
"Undershirts_120_F": "Pixel T-shirt №3",
"Undershirts_121_F": "Pixel T-shirt №4",
"Undershirts_122_F": "Pixel T-shirt №5",
"Undershirts_123_F": "Pixel T-shirt №6",
"Undershirts_124_F": "Pixel T-shirt №7",
"Undershirts_125_F": "Pixel T-shirt №8",
"Undershirts_126_F": "Pixel T-shirt №9",
"Undershirts_127_F": "Pixel T-shirt №10",
"Undershirts_128_F": "Pixel T-shirt №11",
"Undershirts_129_F": "Pixel T-shirt №12",
"Undershirts_130_F": "Pixel T-shirt №13",
"Undershirts_131_F": "Pixel T-shirt №14",
"Undershirts_132_F": "Pixel T-shirt №15",
"Undershirts_133_F": "Pixel T-shirt №16",
"Undershirts_134_F": "Pixel T-shirt №17",
"Undershirts_135_F": "Pixel T-shirt №18",
"Undershirts_136_F": "Pixel T-shirt №19",
"Undershirts_137_F": "Pixel T-shirt №20",
"Undershirts_138_F": "Pixel T-shirt №21",
"Undershirts_139_F": "Pixel T-shirt №22",
"Undershirts_140_F": "Pixel T-shirt №23",
"Undershirts_141_F": "Pixel T-shirt №24",
"Undershirts_142_F": "T-shirt №41",
"Undershirts_143_F": "T-shirt №42",
"Undershirts_144_F": "T-shirt №43",
"Undershirts_145_F": "T-shirt №44",
"Undershirts_146_F": "T-shirt #45",
"Undershirts_147_F": "T-shirt #46",
"Undershirts_148_F": "-",
"Undershirts_149_F": "Polo №1",
"Undershirts_150_F": "Polo №2",
"Undershirts_151_F": "T-shirt №9",
"Undershirts_152_F": "-",
"Undershirts_153_F": "-",
"Undershirts_154_F": "Vest pilot №1",
"Undershirts_155_F": "Motorcycle vest №1",
"Undershirts_156_F": "Motorcycle vest №2",
"Undershirts_157_F": "Motorcycle vest №3",
"Undershirts_158_F": "Motorcycle vest №4",
"Undershirts_159_F": "-",
"Undershirts_160_F": "-",
"Undershirts_161_F": "Bulletproof vest",
"Undershirts_162_F": "T-shirt №47",
"Undershirts_163_F": "T-shirt №48",
"Undershirts_164_F": "T-shirt #49",
"Undershirts_165_F": "T-shirt #50",
"Undershirts_166_F": "T-shirt #51",
"Undershirts_167_F": "T-shirt #52",
"Undershirts_168_F": "T-shirt #53",
"Undershirts_169_F": "T-shirt #54",
"Undershirts_170_F": "T-shirt №55",
"Undershirts_171_F": "T-shirt №56",
"Undershirts_172_F": "T-shirt №57",
"Undershirts_173_F": "T-shirt №58",
"Undershirts_174_F": "-",
"Undershirts_175_F": "Topic №4",
"Undershirts_176_F": "Topic #5",
"Undershirts_177_F": "-",
"Undershirts_178_F": "T-shirt #59",
"Undershirts_179_F": "T-shirt #60",
"Undershirts_180_F": "T-shirt №61",
"Undershirts_181_F": "T-shirt №62",
"Undershirts_182_F": "T-shirt №63",
"Undershirts_183_F": "T-shirt №64",
"Undershirts_184_F": "-",
"Undershirts_185_F": "Shirt №9",
"Undershirts_186_F": "Part of the super hero costume",
"Undershirts_187_F": "Part of the diver's suit",
"Undershirts_188_F": "Vest №1",
"Undershirts_189_F": "-",
"Undershirts_190_F": "-",
"Undershirts_191_F": "-",
"Undershirts_192_F": "Motorcycle vest №5",
"Undershirts_193_F ": "Shirt #10",
"Undershirts_194_F": "Shirt #11",
"Undershirts_195_F": "Bulletproof vest with shirt №1",
"Undershirts_196_F": "Bulletproof vest with shirt №2",
"Undershirts_197_F": "Bulletproof vest with shirt №3",
"Undershirts_198_F": "Bulletproof vest with shirt №4",
"Undershirts_199_F": "Vest №2",
" Undershirts_200_F": "Vest №3",
"Ears_0_M": "Headset №1",
"Ears_1_M": "Headset №2",
"Ears_2_M": "Headset №3",
"Ears_3_M": "-",
"Ears_4_M": "Ring №1",
"Ears_5_M": "Ring №2",
"Ears_6_M": "-",
"Ears_7_M": "With round diamond №1",
"Ears_8_M": "With round diamond №2",
"Ears_9_M": "-",
"Ears_10_M": "Diamonds №1",
"Ears_11_M": "Diamonds #2",
"Ears_12_M": "-",
"Ears_13_M": "Earring #1",
"Ears_14_M": "Earring #2",
"Ears_15_M": "-",
"Ears_16_M": "Earring #3",
"Ears_17_M": "Earring #4",
"Ears_18_M": "-",
"Ears_19_M": "Earring #5",
"Ears_20_M": "Earring #6",
"Ears_21_M": "-",
"Ears_22_M": "Earring #7",
"Ears_23_M": "Earring #8",
"Ears_24_M": "-",
"Ears_25_M": "Skull Earring №1",
"Ears_26_M": "Skull Earring №2",
"Ears_27_M": "-",
"Ears_28_M": "Earring №9",
"Ears_29_M": "Earring №10",
"Ears_30_M": "-",
"Ears_31_M": "Earring №11",
"Ears_32_M": "Earring №12",
"Ears_33_M": "-",
"Ears_34_M": "-",
"Ears_35_M": "Earring #13",
"Ears_36_M": "Earring #14",
"Ears_37_M": "Earring #15",
"Ears_38_M": "Earring 'Cards'",
"Ears_39_M": "Earring 'Bones'",
"Ears_40_M": "Earring 'Chip'",
"Watches_0_M": "Q&Q VR8",
"Watches_1_M": "Skmei 1068-5",
"Watches_2_M": "-",
"Watches_3_M": "Timex T49",
"Watches_4_M": "Skagen SKW64",
"Watches_5_M": "Esprit ES1",
"Watches_6_M": "Casio GBA-800DG",
"Watches_7_M": "Orient FER27",
"Watches_8_M": "Tissot T117",
"Watches_9_M": "Certina C035",
"Watches_10_M": "Skmei 1471-3",
"Watches_11_M": "Pierre Lannier",
"Watches_12_M": "Jacques Lemans 1-207",
"Watches_13_M": "Amvox",
"Watches_14_M": "Master",
"Watches_15_M": "Aquaracer",
"Watches_16_M": "Hawk",
"Watches_17_M": "Carrera",
"Watches_18_M": "Marine",
"Watches_19_M": "Sport",
"Watches_20_M": "Defy",
"Watches_21_M": "Diver",
"Watches_22_M": "Silver Bracelet №1",
"Watches_23_M": "Silver bracelet №2",
"Watches_24_M": "Silver bracelet №3",
"Watches_24_M": "Silver bracelet №4",
"Watches_26_M": "Silver bracelet №5",
"Watches_27_M": "Bracelet with beads",
"Watches_28_M": "Studded Bracelet",
"Watches_29_M": "Wristband",
"Watches_30_M": "Classic",
"Watches_31_M": "Business",
"Watches_32_M": "Business status",
"Watches_33_M": "Classic fresh",
"Watches_34_M": "Compact classic",
"Watches_35_M": "Mechanical",
"Watches_36_M": "Casual",
"Watches_37_M": "Large classic",
"Watches_38_M": "SASS",
"Watches_39_M": "SASS №2",
"Undershirts_0_M": "T-shirt №1",
"Undershirts_1_M": "T-shirt №2",
"Undershirts_2_M": "T-shirt №3",
"Undershirts_3_M": "Shirt with vest №1",
"Undershirts_4_M": "Shirt with vest №2",
"Undershirts_5_M": "T-shirt №4",
"Undershirts_6_M": "Shirt №1",
"Undershirts_7_M": "Shirt #2",
"Undershirts_8_M": "T-shirt #5",
"Undershirts_9_M": "Polo #1",
"Undershirts_10_M": "Shirt #3",
"Undershirts_11_M": "Shirt #4",
"Undershirts_12_M": "Shirt #5",
"Undershirts_13_M": "Shirt #6",
"Undershirts_14_M": "T-shirt #6",
"Undershirts_15_M": "-",
"Undershirts_16_M": "T-shirt #7",
"Undershirts_17_M": "T-shirt #8",
"Undershirts_18_M": "T-shirt #9",
"Undershirts_19_M": "New Year's T-shirt №1",
"Undershirts_20_M": "New Year's T-shirt №2",
"Undershirts_21_M": "Shirt №7",
"Undershirts_22_M": "Shirt №8",
"Undershirts_23_M": "T-shirt №10",
"Undershirts_24_M": "T-shirt №11",
"Undershirts_25_M": "Shirt with vest №3",
"Undershirts_26_M": "Shirt with vest №4",
"Undershirts_27_M": "Shirt №9",
"Undershirts_28_M": "Shirt №10",
"Undershirts_29_M": "Shirt №11",
"Undershirts_30_M": "Shirt №12",
"Undershirts_31_M": "Shirt №13",
"Undershirts_32_M": "Shirt №14",
"Undershirts_33_M": "Shirt with vest №5",
"Undershirts_34_M": "Shirt with vest №6",
"Undershirts_35_M": "Shirt with vest №7",
"Undershirts_36_M": "Shirt with vest №8",
"Undershirts_37_M": "T-shirt №12",
"Undershirts_38_M": "T-shirt №13",
"Undershirts_39_M": "T-shirt №14",
"Undershirts_40_M": "T-shirt №15",
"Undershirts_41_M": "T-shirt №16",
"Undershirts_42_M": "Polo №2",
"Undershirts_43_M": "Shirt #15",
"Undershirts_44_M": "T-shirt #17",
"Undershirts_45_M": "Shirt #16",
"Undershirts_46_M": "Shirt #17",
"Undershirts_47_M": "T-shirt #18",
"Undershirts_48_M": "T-shirt #19",
"Undershirts_49_M": "Shirt №18",
"Undershirts_50_M": "Shirt №19",
"Undershirts_51_M": "Shirt with vest 'Patriot' №1",
"Undershirts_52_M": "Shirt with vest 'Patriot' №2",
"Undershirts_53_M": "T-shirt №20",
"Undershirts_54_M": "T-shirt №21",
"Undershirts_55_M": "Vest №1",
"Undershirts_56_M": "Vest №2",
"Undershirts_57_M": "-",
"Undershirts_58_M": "-",
"Undershirts_59_M": "Work Vest",
"Undershirts_60_M": "Shirt №20",
"Undershirts_61_M": "-",
"Undershirts_62_M": "-",
"Undershirts_63_M": "Shirt №21",
"Undershirts_64_M": "Shirt №22",
"Undershirts_65_M": "T-shirt with gold pattern №1",
"Undershirts_66_M": "T-shirt with gold pattern №2",
"Undershirts_67_M": "T-shirt №22",
"Undershirts_68_M": "T-shirt №23",
"Undershirts_69_M": "Shirt №23",
"Undershirts_70_M": "Shirt №24",
"Undershirts_71_M": "T-shirt №24",
"Undershirts_72_M": "T-shirt №25",
"Undershirts_73_M": "Shirt №25",
"Undershirts_74_M": "T-shirt №26",
"Undershirts_75_M": "T-shirt №27",
"Undershirts_76_M": "T-shirt №28",
"Undershirts_77_M": "T-shirt №29",
"Undershirts_78_M": "-",
"Undershirts_79_M": "Nagasaki T-shirt №1",
"Undershirts_80_M": "Nagasaki T-shirt №2",
"Undershirts_81_M": "T-shirt №30",
"Undershirts_82_M": "Fashionable T-shirt №1",
"Undershirts_83_M": "T-shirt №31",
"Undershirts_84_M": "Fashionable T-shirt №2",
"Undershirts_85_M": "T-shirt №32",
"Undershirts_86_M": "Fashionable T-shirt №3",
"Undershirts_87_M": "T-shirt №33",
"Undershirts_88_M": "T-shirt #34",
"Undershirts_89_M": "T-shirt #35",
"Undershirts_90_M": "Shirt #26",
"Undershirts_91_M": "Shirt with vest",
"Undershirts_92_M": "T-shirt with vest",
"Undershirts_93_M": "Shirt #27",
"Undershirts_94_M": "Shirt #28",
"Undershirts_95_M": "Shirt #29",
"Undershirts_96_M": "Shirt #30",
"Undershirts_97_M": "Bulletproof suit",
"Undershirts_98_M": "Camouflage T-shirt №1",
"Undershirts_99_M": "Camouflage T-shirt №2",
"Undershirts_100_M": "Camouflage T-shirt №3",
"Undershirts_101_M": "Camouflage T-shirt №4",
"Undershirts_102_M ": "Camouflage T-shirt №5",
"Undershirts_103_M": "T-shirt №36",
"Undershirts_104_M": "T-shirt №37",
"Undershirts_105_M": "T-shirt №38",
"Undershirts_106_M": "T-shirt №39",
"Undershirts_107_M": "T-shirt №40",
"Undershirts_108_M": "-",
"Undershirts_109_M": "Polo №3",
"Undershirts_110_M": "Polo №4",
"Undershirts_111_M": "T-shirt №41",
"Undershirts_112_M": "T-shirt №42",
"Undershirts_113_M": "T-shirt №43",
"Undershirts_114_M": "T-shirt №44",
"Undershirts_115_M": "T-shirt №45",
"Undershirts_116_M": "T-shirt №46",
"Undershirts_117_M": "Camouflage T-shirt №6",
"Undershirts_118_M": "Camouflage T-shirt №7",
"Undershirts_119_M": "Camouflage T-shirt №8",
"Undershirts_120_M": "Camouflage T-shirt №9",
"Undershirts_121_M": "Camouflage T-shirt №10",
" Undershirts_122_M": "-",
"Undershirts_123_M": "-",
"Undershirts_124_M": "-",
"Undershirts_125_M": "Pilot's vest №1",
"Undershirts_126_M": "Motorcycle vest №1",
"Undershirts_127_M": "Motorcycle vest №2",
"Undershirts_128_M": "Motorcycle vest №3",
"Undershirts_129_M": "-",
"Undershirts_130_M": "-",
"Undershirts_131_M": "Bulletproof vest №1",
"Undershirts_132_M": "T-shirt №47",
"Undershirts_133_M": "T-shirt №48",
"Undershirts_134_M": "T-shirt №49",
"Undershirts_135_M": "T-shirt №50",
"Undershirts_136_M": "T-shirt №51",
"Undershirts_137_M": "-",
"Undershirts_138_M": "T-shirt №52",
"Undershirts_139_M": "T-shirt №53",
"Undershirts_140_M": "T-shirt №54",
"Undershirts_141_M": "T-shirt №55",
"Undershirts_142_M": "T-shirt №56",
"Undershirts_143_M": "-",
"Undershirts_144_M": "Shirt №31",
"Undershirts_145_M": "Part of the super hero costume",
"Undershirts_146_M": "Shirt with vest №10",
"Undershirts_147_M": "Shirt with vest №11",
"Undershirts_148_M": "Shirt with vest №12",
"Undershirts_149_M": "Shirt with vest №13",
"Undershirts_150_M": "Shirt №32",
"Undershirts_151_M": "Part of the diver's suit",
"Undershirts_152_M": "Vest №3",
"Undershirts_153_M": "-",
"Undershirts_154_M": "-",
"Undershirts_155_M": "-",
"Undershirts_156_M": "Motorcycle vest №5",
"Undershirts_157_M": "Shirt №33",
"Undershirts_158_M": "Shirt №34",
"Undershirts_159_M": "Shirt with bulletproof vest №1",
"Undershirts_160_M": "Shirt with bulletproof vest №2",
"Undershirts_161_M": "Shirt with bulletproof vest №3",
"Undershirts_162_M": "Shirt with bulletproof vest №4",
"Undershirts_163_M": "Vest №4",
"Undershirts_164_M": "Bulletproof vest №2",
"Legs_0_M": "Cookie jeans",
"Legs_1_M": "Rapper jeans",
"Legs_2_M": "Chess shorts",
"Legs_3_M": "Sweatpants",
"Legs_4_M": "Skinny jeans",
"Legs_5_M": "Big sweatpants",
"Legs_6_M": "Shorts with pockets",
"Legs_7_M": "Classic pants",
"Legs_8_M": "Classic pants fresh",
"Legs_9_M": "Pants with side pockets",
"Legs_10_M": "Classic trousers",
"Legs_11_M": "-",
"Legs_12_M": "Plain shorts",
"Legs_13_M": "Classic trousers fresh",
"Legs_14_M": "Short beach shorts",
"Legs_15_M": "Shorts with side pockets",
"Legs_16_M": "Beach shorts",
"Legs_17_M": "Walking shorts",
"Legs_18_M": "Stylish beach shorts",
"Legs_19_M": "Classic trousers refined",
"Legs_20_M": "Classic trousers fresh",
"Legs_21_M": "Underpants",
"Legs_22_M": "Classic trousers elegant",
"Legs_23_M": "Classic status trousers",
"Legs_24_M": "Skinny trousers",
"Legs_25_M": "Classic trousers are strict",
"Legs_26_M": "Skinny trousers are fresh",
"Legs_27_M": "Loose trousers",
"Legs_28_M": "Skinny trousers are strict",
"Legs_29_M": "Striped trousers",
"Legs_30_M": "Pilot pants",
"Legs_31_M": "Short pants",
"Legs_32_M": "Long johns",
"Legs_33_M": "Joggers",
"Legs_34_M": "Combat pants",
"Legs_35_M": "Classic trousers modern",
"Legs_36_M": "Work pants",
"Legs_37_M": "Classic branded trousers",
"Legs_38_M": "Classic elegant trousers",
"Legs_39_M": "Classic fresh trousers",
"Legs_40_M": "Street sweatpants",
"Legs_41_M": "Pilot pants",
"Legs_42_M": "Loose shorts",
"Legs_43_M": "Loose jeans",
"Legs_44_M": "-",
"Legs_45_M": "Skinny stylish pants",
"Legs_46_M": "Pilot pants",
"Legs_47_M": "Fresh work pants",
"Legs_48_M": "Classic universal trousers",
"Legs_49_M": "Skinny trousers",
"Legs_50_M": "Classic trousers with a twist",
"Legs_51_M": "Trousers with a pattern",
"Legs_52_M": "Narrowed trousers are strict",
"Legs_53_M": "Narrowed trousers with a pattern",
"Legs_54_M": "Beach shorts",
"Legs_55_M": "Loose sweatpants",
"Legs_56_M": "Towel",
"Legs_57_M": "Breeches",
"Legs_58_M": "Pajama pants",
"Legs_59_M": "Free joggers",
"Legs_60_M": "Plaid pajama pants",
"Legs_61_M": "Family underpants",
"Legs_62_M": "Karate breeches",
"Legs_63_M": "Classic jeans",
"Legs_64_M": "Loose Abibas Sweatpants",
"Legs_65_M": "Pajama pants",
"Legs_66_M": "Motorcycle pants with a cut-out",
"Legs_67_M": "Motorcycle pants with knee pads",
"Legs_68_M": "Stunt pants with a flag",
"Legs_69_M": "Pants with skulls",
"Legs_70_M": "Stunt cowboy pants",
"Legs_71_M": "Tight leather pants",
"Legs_72_M": "Leather pants short",
"Legs_73_M": "Motorcycle protective pants",
"Legs_74_M": "Motorcycle protective pants short",
"Legs_75_M": "Ripped jeans",
"Legs_76_M": "Ripped jeans",
"Legs_77_M": "Neon pants",
"Legs_78_M": "Skinny sweatpants",
"Legs_79_M": "Narrowed matte sweatpants",
"Legs_80_M": "Fabric breeches",
"Legs_81_M": "Latex breeches",
"Legs_82_M": "Narrowed fabric jeans",
"Legs_83_M": "Narrowed latex jeans",
"Legs_84_M": "Part of a bulletproof suit",
"Legs_85_M": "Neon Leggings",
"Legs_86_M": "Camouflage pants",
"Legs_87_M": "Camouflage jogger pants",
"Legs_88_M": "Camouflage shorts",
"Legs_89_M": "Military camouflage pants",
"Legs_90_M": "Classic jeans with inserts",
"Legs_91_M": "Sweatpants with a cuff",
"Legs_92_M": "Pilot pants with straps",
"Legs_93_M": "Pilot pants with suspenders",
"Legs_94_M": "Insulated leggings",
"Legs_95_M": "Matrix leggings",
"Legs_96_M": "Classic plain pants",
"Legs_97_M": "Work pants joggers",
"Legs_98_M": "Wide work pants",
"Legs_99_M": "Loose light sweatpants",
"Legs_100_M": "Loose pants with flowers",
"Legs_101_M": "Bologna pants",
"Legs_102_M": "Loose pants with chains",
"Legs_103_M": "Breeches with chains",
"Legs_104_M": "Classic loose pants",
"Legs_105_M": "Classic stylish trousers",
"Legs_106_M": "Futuristic leggings",
"Legs_107_M": "Heroic breeches",
"Legs_108_M": "Part of the 'Monster' costume",
"Legs_109_M": "Astronaut pants",
"Legs_110_M": "Han Solo astronaut pants",
"Legs_111_M": "Maniac pants",
"Legs_112_M": "Banana astronaut pants",
"Legs_113_M": "Eco astronaut pants",
"Legs_114_M": "Robot suit pants",
"Legs_115_M": "Tight pants",
"Legs_116_M": "Trendy skinny pants",
"Legs_117_M": "Beach shorts",
"Legs_118_M": "Fashionable loose pants ",
"Legs_119_M": "Lower part of the Emperor's robe",
"Legs_120_M": "Firefighter's pants",
"Legs_121_M": "Policeman's pants",
"Legs_122_M": "Loose gray pants",
"Legs_123_M": "Narrowed pants",
"Legs_124_M": "Racing pants",
"Legs_125_M": "Padded pants",
"Legs_131_M": "Skinny pants",
"Legs_133_M": "Dark Jeans",
"Legs_134_M": "Fresh pants",
"Legs_136_M": "Rapper Shorts",
"Legs_137_M": "Funny Underpants",
"Legs_0_F": "Skinny Jeans",
"Legs_1_F": "Loose jeans",
"Legs_2_F": "Sweatpants",
"Legs_3_F": "Loose trousers",
"Legs_4_F": "Skinny jeans with flaps",
"Legs_5_F": "Domino shorts",
"Legs_6_F": "Classic office trousers",
"Legs_7_F": "Knee-length skirt",
"Legs_8_F": "Mini skirt",
"Legs_9_F": "Multicolored mini skirt",
"Legs_10_F": "Sports shorts",
"Legs_11_F": "Track pants with flaps",
"Legs_12_F": "Tennis skirt",
"Legs_13_F": "-",
"Legs_14_F": "Blue shorts",
"Legs_15_F": "Elegant underpants",
"Legs_16_F": "Beach shorts",
"Legs_17_F": "Fresh underpants",
"Legs_18_F": "Business skirt",
"Legs_19_F": "Lace shorts",
"Legs_20_F": "Wedding stockings",
"Legs_21_F": "Soft underpants",
"Legs_22_F": "Seductive Stockings",
"Legs_23_F": "Business trousers",
"Legs_24_F": "Multicolored skirt",
"Legs_25_F": "Denim shorts",
"Legs_26_F": "Leopard skirt",
"Legs_27_F": "Leggings leather",
"Legs_28_F": "Striped skirt",
"Legs_29_F": "Parachutist pants",
"Legs_30_F": "Street breeches",
"Legs_31_F": "Skinny leggings",
"Legs_32_F": "Joggers",
"Legs_33_F": "Pants for riding a motorcycle",
"Legs_34_F": "Black business pants",
"Legs_35_F": "Work pants",
"Legs_36_F": "Classic skirt",
"Legs_37_F": "Classic stylish trousers",
"Legs_38_F": "Loose trousers",
"Legs_39_F": "Loose trousers fresh",
"Legs_40_F": "Sweatpants",
"Legs_41_F": "Loose trousers",
"Legs_42_F": "Pilot trousers",
"Legs_43_F": "Jeans with slits",
"Legs_44_F": "Jeans with slits on the sides",
"Legs_45_F": "Universal work pants",
"Legs_46_F": "-",
"Legs_47_F": "Classic elegant trousers",
"Legs_48_F": "Pilot pants",
"Legs_49_F": "Practical work pants",
"Legs_50_F": "Loose business trousers",
"Legs_51_F": "Narrowed business trousers",
"Legs_52_F": "Classic trousers on the way out",
"Legs_53_F": "Classic trousers with a pattern",
"Legs_54_F": "Skinny Leggings fresh",
"Legs_55_F": "Skinny Leggings with a pattern",
"Legs_56_F": "Amazing Underpants",
"Legs_57_F": "Towel",
"Legs_58_F": "Loose sweatpants",
"Legs_59_F": "Loose breeches",
"Legs_60_F": "Checkered pants",
"Legs_61_F": "Work pants",
"Legs_62_F": "Silk panties",
"Legs_63_F": "Stockings with panties",
"Legs_64_F": "Narrowed business pants",
"Legs_65_F": "Wide business pants",
"Legs_66_F": "Street sports pants",
"Legs_67_F": "Pajama pants",
"Legs_68_F": "Sports pants with a cuff",
"Legs_69_F": "Motorcycle pants",
"Legs_70_F": "Stunt pants",
"Legs_71_F": "Loose pants",
"Legs_72_F": "Pants with stars",
"Legs_73_F": "Skinny jeans with a pattern",
"Legs_74_F": "Skinny ripped jeans",
"Legs_75_F": "Skinny jeans universal",
"Legs_76_F": "Skinny jeans tight",
"Legs_77_F": "Skinny skinny jeans",
"Legs_78_F": "Denim shorts with stockings",
"Legs_79_F": "Neon pants",
"Legs_80_F": "Skinny jogger sweatpants",
"Legs_81_F": "Skinny latex sweatpants",
"Legs_82_F": "Sports breeches",
"Legs_83_F": "Latex sports breeches",
"Legs_84_F": "Handmade Skinny Jeans",
"Legs_85_F": "Handmade Latex Skinny Jeans",
"Legs_86_F": "Part of a bulletproof Suit",
"Legs_87_F": "Camouflage Leggings",
"Legs_88_F": "Neon Leggings",
"Legs_89_F": "Camouflage Pants",
"Legs_90_F": "Camouflage skinny pants",
"Legs_91_F": "Camouflage shorts",
"Legs_92_F": "Camouflage loose pants",
"Legs_93_F": "Loose jeans",
"Legs_94_F": "Stylish sports pants with a cuff",
"Legs_95_F": "Pilot pants with straps",
"Legs_96_F": "Pilot pants with suspenders",
"Legs_97_F": "Sports Leggings",
"Legs_98_F": "Leggings 'Matrix'",
"Legs_99_F": "Loose trousers strict",
"Legs_100_F": "Skinny work pants",
"Legs_101_F": "Loose work pants",
"Legs_102_F": "Skinny pants with garter belt",
"Legs_103_F": "Loose lightweight sweatpants",
"Legs_104_F": "Loose pants with flowers",
"Legs_105_F": "Balloon pants",
"Legs_106_F": "Skinny pants with zippers",
"Legs_107_F": "Short shorts",
"Legs_108_F": "Chameleon skirt",
"Legs_109_F": "Biker loose pants",
"Legs_110_F": "Biker loose breeches",
"Legs_111_F": "Loose sea pants",
"Legs_112_F": "Skinny street jeans",
"Legs_113_F": "Tight leggings",
"Legs_114_F": "Pilot Breeches",
"Legs_115_F": "Part of the 'Monster' costume",
"Legs_116_F": "Astronaut pants with knee pads",
"Legs_117_F": "Astronaut pants cut off",
"Legs_118_F": "Sweatpants with blood",
"Legs_119_F": "Astronaut pants 'Banana'",
"Legs_120_F": "Tight astronaut pants",
"Legs_121_F": "Robot pants",
"Legs_122_F": "Classic breeches",
"Legs_123_F": "Beach shorts",
"Legs_124_F": "Classic trousers with patterns",
"Legs_125_F": "Towel with patterns",
"Legs_126_F": "Firefighter pants",
"Legs_127_F": "Policeman pants",
"Legs_128_F": "Loose pants with pockets",
"Legs_129_F": "Skinny pants with pockets",
"Legs_130_F": "Racing pants",
"Legs_131_F": "Pants with lining",
"Tops_0_M": "T-shirt",
"Tops_1_M": "Stylish T-shirt",
"Tops_2_M": "Domino T-shirt",
"Tops_3_M": "Beginner's jacket",
"Tops_4_M": "Business jacket",
"Tops_5_M": "T-shirt №1",
"Tops_6_M": "Leather jacket with white inserts",
"Tops_7_M": "Sports jacket",
"Tops_8_M": "Courier T-shirt",
"Tops_9_M": "Striped Polo",
"Tops_10_M": "Closed jacket",
"Tops_11_M": "Stripper vest",
"Tops_12_M": "Long-sleeved shirt",
"Tops_13_M": "Shirt with rolled up sleeves",
"Tops_14_M": "Plaid shirt",
"Tops_15_M": "-",
"Tops_16_M": "T-shirt №4",
"Tops_17_M": "T-shirt №5",
"Tops_18_M": "New Year's T-shirt",
"Tops_19_M": "Jacket №3",
"Tops_20_M": "Godfather Jacket",
"Tops_21_M": "Stripper Vest",
"Tops_22_M": "T-shirt №6",
"Tops_23_M": "Jacket №5",
"Tops_24_M": "Jacket №6",
"Tops_25_M": "Vest №3",
"Tops_26_M": "Shirt №4",
"Tops_27_M": "Jacket №7",
"Tops_28_M": "Jacket №8",
"Tops_29_M": "Jacket №9",
"Tops_30_M": "Jacket №10",
"Tops_31_M": "Jacket №11",
"Tops_32_M": "Jacket №12",
"Tops_33_M": "T-shirt №7",
"Tops_34_M": "T-shirt №8",
"Tops_35_M": "Jacket №13",
"Tops_36_M": "T-shirt №2",
"Tops_37_M": "Jacket №2",
"Tops_38_M": "T-shirt №9",
"Tops_39_M": "Polo №2",
"Tops_40_M": "Vest №4",
"Tops_41_M": "Shirt №5",
"Tops_42_M": "Shirt №6",
"Tops_43_M": "Shirt №7",
"Tops_44_M": "T-shirt №10",
"Tops_45_M": "Patriot Vest",
"Tops_46_M": "Patriot Jacket",
"Tops_47_M": "Street T-shirt",
"Tops_48_M": "Pilot jacket №1",
"Tops_49_M": "Protective jacket №1",
"Tops_50_M": "Jacket №2",
"Tops_51_M": "New Year's Sweatshirt",
"Tops_52_M": "Sweatshirt №1",
"Tops_53_M": "Protective jacket №2",
"Tops_54_M": "Pilot jacket №2",
"Tops_55_M": "Police shirt",
"Tops_56_M": "Dirty T-shirt №1",
"Tops_57_M": "Jacket №1",
"Tops_58_M": "Jacket №14",
"Tops_59_M": "Dirty jacket №1",
"Tops_60_M": "Dirty Jacket №2",
"Tops_61_M": "Jacket №2",
"Tops_62_M": "Jacket №3",
"Tops_63_M": "Shirt №8",
"Tops_64_M": "Leather jacket №2",
"Tops_65_M": "Jacket №4",
"Tops_66_M": "Cropped jacket",
"Tops_67_M": "Sweatshirt №2",
"Tops_68_M": "Jacket №5",
"Tops_69_M": "Jacket №6",
"Tops_70_M": "Leather jacket with fur №1",
"Tops_71_M": "T-shirt №12",
"Tops_72_M": "Long coat №1",
"Tops_73_M": "T-shirt with a golden pattern",
"Tops_74_M": "Fashionable jacket №1",
"Tops_75_M": "Fashionable jacket №2",
"Tops_76_M": "Coat №1",
"Tops_77_M": "Long coat №2",
"Tops_78_M": "Sweatshirt №3",
"Tops_79_M": "Jacket №3",
"Tops_80_M": "T-shirt №13",
"Tops_81_M": "T-shirt №14",
"Tops_82_M": "Polo №3",
"Tops_83_M": "T-shirt №15",
"Tops_84_M": "Jacket 'Corkers'",
"Tops_85_M": "Jacket №7",
"Tops_86_M": "Jacket №4",
"Tops_87_M": "Jacket 'Double' №1",
"Tops_88_M": "Jacket 'Double' №2",
"Tops_89_M": "Sweatshirt №4",
"Tops_90_M": "Jacket №5",
"Tops_91_M": "-",
"Tops_92_M": "Shirt №9",
"Tops_93_M": "Polo 'Andreas' №1",
"Tops_94_M": "Polo 'Andreas' №2",
"Tops_95_M": "Shirt №10",
"Tops_96_M": "Jacket 'FB'",
"Tops_97_M": "Beginner's T-shirt",
"Tops_98_M": "Dirty T-shirt №2",
"Tops_99_M": "Jacket №15",
"Tops_100_M": "Jacket №16",
"Tops_101_M": "Jacket №17",
"Tops_102_M": "Checkered jacket",
"Tops_103_M": "Jacket with a forest pattern",
"Tops_104_M": "Jacket with a forest pattern with sleeves",
"Tops_105_M": "Shirt with flowers",
"Tops_106_M": "Down jacket",
"Tops_107_M": "Japanese-style robe",
"Tops_108_M": "Kumite jacket",
"Tops_109_M": "Handmade jacket",
"Tops_110_M": "Jacket with belt",
"Tops_111_M": "Sweatshirt",
"Tops_112_M": "Coat with buttons", 
"Tops_113_M": "Olympic jacket with logo",
"Tops_114_M": "Robe",
"Tops_115_M": "Elongated coat",
"Tops_116_M": "New Year jacket",
"Tops_117_M": "Plaid shirt",
"Tops_118_M": "Motorcycle jacket with inserts",
"Tops_119_M": "Business jacket",
"Tops_120_M": "Business vest",
"Tops_121_M": "Rastafarian jacket",
"Tops_122_M": "Fashionable jacket",
"Tops_123_M": "Polo with zipper",
"Tops_124_M": "Kid's jacket",
"Tops_125_M": "Homo jacket",
"Tops_126_M": "Gangster shirt",
"Tops_127_M": "Street racer shirt",
"Tops_128_M": "Baseball T-shirt",
"Tops_129_M": "SecuroServ jacket",
"Tops_130_M": "Jacket 'SecuroServ' unbuttoned",
"Tops_131_M": "Polo 'Liberty'",
"Tops_132_M": "Short polo 'Liberty'",
"Tops_133_M": "Shirt tucked in",
"Tops_134_M": "Jacket 'Liberty'",
"Tops_135_M": "Shirt with birds",
"Tops_136_M": "Down jacket with belt",
"Tops_137_M": "Jumper",
"Tops_138_M": "Worn leather jacket",
"Tops_139_M": "Turtleneck",
"Tops_140_M": "Wool coat",
"Tops_141_M": "Olympic jacket with stripes",
"Tops_142_M": "Unbuttoned coat",
"Tops_143_M": "Baseball jacket",
"Tops_144_M": "Nightgown",
"Tops_145_M": "Bathrobe №2",
"Tops_146_M": "T-shirt",
"Tops_147_M": "Motorcycle jacket 'Glamour'",
"Tops_148_M": "Motorcycle jacket 'Muratti'",
"Tops_149_M": "Stunt shirt 'Clober'",
"Tops_150_M": "Jacket with a pattern",
"Tops_151_M": "Mechanic's jacket 'CowBoy'",
"Tops_152_M": "Nagasaki Sweatshirt",
"Tops_153_M": "Youth Bomber",
"Tops_154_M": "Country Jacket",
"Tops_155_M": "Extreme Stunt Shirt",
"Tops_156_M": "Mechanic Jacket №2",
"Tops_157_M": "Vest №1",
"Tops_158_M": "Vest №2",
"Tops_159_M": "Vest №3",
"Tops_160_M": "Vest №4",
"Tops_161_M": "Biker Jacket №1",
"Tops_162_M": "Biker Vest",
"Tops_163_M": "Denim jacket",
"Tops_164_M": "Long T-shirt",
"Tops_165_M": "Camouflage jacket",
"Tops_166_M": "Leather jacket with inserts",
"Tops_167_M": "Open down jacket",
"Tops_168_M": "Forest jacket",
"Tops_169_M": "Denim jacket №1",
"Tops_170_M": "Denim vest №2",
"Tops_171_M": "Jacket №11",
"Tops_172_M": "Denim jacket №2",
"Tops_173_M": "Denim vest №2",
"Tops_174_M": "Biker jacket №2",
"Tops_175_M": "Biker Vest",
"Tops_176_M": "Vest 'STFU'",
"Tops_177_M": "Vest №6",
"Tops_178_M": "Neon jacket",
"Tops_179_M": "Vest №7",
"Tops_180_M": "Vest №8",
"Tops_181_M": "Leather jacket №4",
"Tops_182_M": "Jacket №12",
"Tops_183_M": "Jacket in strip",
"Tops_184_M": "Long hooded jacket",
"Tops_185_M": "Long Jacket №2",
"Tops_186_M": "Part of a bulletproof suit",
"Tops_187_M": "Coat",
"Tops_188_M": "Jacket №18",
"Tops_189_M": "Jacket №19",
"Tops_190_M": "Striped Sweatshirt",
"Tops_191_M": "Camouflage Jacket",
"Tops_192_M": "Long Coat №3",
"Tops_193_M": "Guffy T-shirt",
"Tops_194_M": "New Year's Sweatshirt №1",
"Tops_195_M": "New Year's Sweatshirt №2",
"Tops_196_M": "Game sweatshirt №1",
"Tops_197_M": "Game sweatshirt №2",
"Tops_198_M": "Jacket with Christmas trees №1",
"Tops_199_M": "Jacket with Christmas trees №2",
"Tops_200_M": "Bright jacket №1",
"Tops_201_M": "Luminous jacket",
"Tops_202_M": "Jacket №13",
"Tops_203_M": "Bright jacket №2",
"Tops_204_M": "Long coat №4",
"Tops_205_M": "Tank top",
"Tops_206_M": "Camouflage tank Top №1",
"Tops_207_M": "Camouflage tank top №2",
"Tops_208_M": "Camouflage T-shirt №1",
"Tops_209_M": "Camouflage jacket №1",
"Tops_210_M": "Camouflage jacket with hood №1",
"Tops_211_M": "Camouflage jacket with hood №2",
"Tops_212_M": "Open camouflage jacket",
"Tops_213_M": "Camouflage vest №1",
"Tops_214_M": "Camouflage Vest №2",
"Tops_215_M": "Camouflage open jacket",
"Tops_216_M": "Camouflage Tank top №3",
"Tops_217_M": "Jacket №20",
"Tops_218_M": "Jacket №21",
"Tops_219_M": "Camouflage tank top №4",
"Tops_220_M": "Camouflage jacket №1",
"Tops_221_M": "Camouflage jacket №2",
"Tops_222_M": "Camouflage jacket with short sleeves",
"Tops_223_M": "Vest №5",
"Tops_224_M": "Jacket #22",
"Tops_225_M": "T-shirt 'Class Of'",
"Tops_226_M": "T-Shirt #19",
"Tops_227_M": "Sports jacket №1",
"Tops_228_M": "Pilot Jacket №3",
"Tops_229_M": "Jacket №23",
"Tops_230_M": "Jacket №24",
"Tops_231_M": "Pilot Jacket №4",
"Tops_232_M": "Jacket №25",
"Tops_233_M": "Jacket №26",
"Tops_234_M": "Shirt №16",
"Tops_235_M": "Polo in stripes №1",
"Tops_236_M": "Polo in stripes №2",
"Tops_237_M": "T-shirt №20",
"Tops_238_M": "T-shirt №21",
"Tops_239_M": "Camouflage T-shirt №2",
"Tops_240_M": "Leather jacket with fur №2",
"Tops_241_M": "Polo №5",
"Tops_242_M": "Polo №6",
"Tops_243_M": "Diving jacket",
"Tops_244_M": "Jacket №27",
"Tops_245_M": "Sweatshirt with a pattern",
"Tops_246_M": "Jacket 'Matrix'",
"Tops_247_M": "Vest №9",
"Tops_248_M": "Motorcycle jacket №4",
"Tops_249_M": "Jacket №15",
"Tops_250_M": "Shirt №17",
"Tops_251_M": "Military jacket №1",
"Tops_252_M": "-",
"Tops_253_M": "Military jacket №2",
"Tops_254_M": "Motorcycle jacket №5",
"Tops_255_M": "Multicolored sweatshirt",
"Tops_256_M": "Jacket with panthers",
"Tops_257_M": "Jacket 'Blogueurs'",
"Tops_258_M": "Jacket with buttons",
"Tops_259_M": "Sweatshirt with drawings",
"Tops_260_M": "Shirt with a pattern",
"Tops_261_M": "Open jacket with panthers",
"Tops_262_M": "Jacket 'Blogueurs' №1",
"Tops_263_M": "Jacket 'Blogueurs' №2",
"Tops_264_M": "Leather jacket",
"Tops_265_M": "Jacket in a circle",
"Tops_266_M": "Open jacket in a circle",
"Tops_267_M": "Jacket №29",
"Tops_268_M": "Jacket №30",
"Tops_269_M": "Multicolored open jacket",
"Tops_270_M": "Motorcycle jacket №6",
"Tops_271_M": "T-shirt №22",
"Tops_272_M": "Sports jacket №2",
"Tops_273_M": "T-shirt №23",
"Tops_274_M": "-",
"Tops_275_M": "Survival jacket №1",
"Tops_276_M": "Survival Jacket №2",
"Tops_277_M": "Part of the 'Monster' costume",
"Tops_278_M": "Part of the 'Astronaut' costume №1",
"Tops_279_M": "Jacket 'Benedict'№1",
"Tops_280_M": "Jacket 'Benedict' №2",
"Tops_281_M": "Sweatshirt 'Burger Shot'",
"Tops_282_M": "Long T-shirt 'Burger'",
"Tops_283_M": "Part of the costume 'Astronaut' №2",
"Tops_284_M": "Jacket with blood",
"Tops_285_M": "Pilot jacket №5",
"Tops_286_M": "Part of the Astronaut suit №3",
"Tops_287_M": "Part of the Robot suit",
"Tops_288_M": "Knitted jacket 'Burger Shot'",
"Tops_289_M": "Part of the suit 'Survivor'",
"Tops_290_M": "Vest №10",
"Tops_291_M": "Part of the super hero costume",
"Tops_292_M": "Jacket with open pattern",
"Tops_293_M": "Jacket with closed pattern",
"Tops_294_M": "Jacket №21",
"Tops_295_M": "Jacket №22",
"Tops_296_M": "Bigness Jacket №1",
"Tops_297_M": "Bigness Jacket №2",
"Tops_298_M": "Bigness Jacket №3",
"Tops_299_M": "UFO shirt",
"Tops_300_M": "Multi-colored Diamond Jacket №1",
"Tops_301_M": "Multi-colored jacket 'Diamond' №2",
"Tops_302_M": "Multi-colored jacket 'Diamond' №3",
"Tops_303_M": "Multi-colored jacket 'Diamond' №4",
"Tops_304_M": "Jacket with fur 'Sacapra'",
"Tops_305_M": "Jacket 'The Diamond' №1",
"Tops_306_M": "Jacket 'The Diamond' №2",
"Tops_307_M": "Sweatshirt 'Broker'",
"Tops_308_M": "Sweatshirt 'Bigness'",
"Tops_309_M": "Jacket 'Broker'",
"Tops_310_M": "Robe",
"Tops_311_M": "Jacket №23",
"Tops_312_M": "Jacket №24",
"Tops_313_M": "T-shirt with pattern №2",
"Tops_314_M": "Firefighter Uniform №1",
"Tops_315_M": "Firefighter Uniform №2",
"Tops_316_M": "Shirt №18",
"Tops_317_M": "Shirt #19",
"Tops_318_M": "Shirt #20",
"Tops_319_M": "Shirt #21",
"Tops_320_M": "Police uniform",
"Tops_321_M": "Shirt №22",
"Tops_322_M": "Shirt №23",
"Tops_323_M": "T-shirt with balls",
"Tops_324_M": "Jacket with protected sleeves",
"Tops_325_M": "T-shirt 'Pixtro'",
"Tops_326_M": "Sweatshirt 'HO-HO-HO'",
"Tops_327_M": "Vest №11",
"Tops_328_M": "Jacket №31",
"Tops_329_M": "Jacket №16",
"Tops_352_M": "Printed T-shirt",
"Tops_353_M": "Printed Hoodie",
"Tops_355_M": "Colored T-shirt",
"Tops_356_M": "Fan T-shirt",
"Tops_358_M": "Fashionable T-shirt",
"Tops_359_M": "Cool T-shirt",
"Tops_360_M": "Unusual T-shirt",
"Tops_361_M": "Phillip Plein Top",
"Tops_363_M": "LV Jacket",
"Tops_368_M": "Police Hoodie",
"Tops_377_M": "Armani T-shirt",
"Tops_378_M": "Fillip Plein T-shirt",
"Tops_382_M": "BAPE T-shirt",
"Tops_379_M": "CK T-shirt",
"Tops_380_M": "Bright Jacket",
"Tops_374_F":"Brand T-shirt",
"Tops_375_F":"Hoodie from France",
"Tops_376_F":"North Face Jacket",
"Tops_377_F":"Nike Sports Top",
"Tops_382_F":"Lace top",
"Tops_383_F":"Evening Top",
"Tops_384_F":"Combinizon top",
"Tops_385_F":"Sweater",
"Tops_385_M":"Leather jacket",
"Tops_386_F":"Cropped jacket",
"Tops_388_F":"Short Top",
"Tops_389_F":"Rainbow Bomber",
"Tops_390_F":"Adidas Sports Top",
"Tops_391_F":"Fashion Bra",
"Tops_393_F":"Street Dress",
"Tops_394_F":"Puffy Dress",
"Tops_407_F":"Puffy Dress",
"Tops_395_F":"Cropped Blouse",
"Tops_396_F":"Latex Suit top",
"Tops_397_F":"Beach Top",
"Tops_398_F":"Oversize T-shirt",
"Tops_399_F":"Cool T-shirt",
"Tops_401_F":"Retro T-shirt",
"Tops_402_F":"Leather jacket",
"Tops_394_F":"Puffy dress",
"Legs_139_F":"Unusual leggings",
"Legs_140_F":"Skirt with leggings",
"Legs_141_F":"Skirt with leggings",
"Legs_142_F":"Intimate underwear",
"Legs_143_F":"Denim shorts with stockings",
"Legs_144_F":"Denim shorts",
"Legs_147_F":"Short denim shorts",
"Legs_148_F":"Bottom of latex suit",
"Legs_149_F":"Adidas sports top",
"Shoes_100_F":"Nike sneakers",
"Shoes_101_F":"Jordana's sneakers",
"Shoes_102_F":"Nike sports sneakers",
"Shoes_103_F":"Outdoor sneakers",
"Shoes_106_F":"Triple S sneakers",
"Shoes_108_F":"Adidas sneakers",
"Shoes_105_M":"BAPE Sneakers",
"Shoes_106_M":"Nike Colored sneakers",
"Shoes_107_M":"Neon sneakers",
"Shoes_107_F":"Neon sneakers",
"Shoes_108_M":"Running sneakers",
"Shoes_108_M":"BAPE sneakers",
"Legs_139_M": "Baggy combat pants",
"Tops_386_M":"Halloween Hoodie",
"Tops_387_M":"Halloween Hoodie reflector",
"Tops_408_F":"Camouflage dress with a belt",
"Tops_409_F":"Dress with a corset",
"Tops_410_F":"Dress with flowers",
"Tops_411_F":"Dress with a zebra",
"Tops_412_F":"Halloween T-shirts",
"Tops_413_F":"Halloween reflex T-shirts",
"Shoes_109_F":"Sports sneakers",
"Shoes_110_F":"Rockstar sneakers",
"Tops_388_M":"Combat jacket",
"Masks_196":"Halloween mask",
"Masks_197":"Witch Hat",
"Tops_403_F":"Luminous T-shirt",
"Tops_405_F":"Luminous Latex T-shirt",
"Legs_150_F":"Luminous latex pants",
}